webpackJsonp([4],{

/***/ "+11S":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "+2Xc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"checkbox",class:_vm.inlineClass},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":Array.isArray(_vm.model)?_vm._i(_vm.model,null)>-1:(_vm.model)},on:{"change":function($event){var $$a=_vm.model,$$el=$event.target,$$c=$$el.checked?(true):(false);if(Array.isArray($$a)){var $$v=null,$$i=_vm._i($$a,$$v);if($$el.checked){$$i<0&&(_vm.model=$$a.concat([$$v]))}else{$$i>-1&&(_vm.model=$$a.slice(0,$$i).concat($$a.slice($$i+1)))}}else{_vm.model=$$c}}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+KYZ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__ = __webpack_require__("WEHx");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue_clickaway___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue_clickaway__);



var GlobalDirectives = {
  install: function install(Vue) {
    Vue.directive('click-outside', __WEBPACK_IMPORTED_MODULE_0_vue_clickaway__["directive"]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalDirectives);

/***/ }),

/***/ "+lQa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"form-group"},[(_vm.label)?_c('label',[_vm._v("\n    "+_vm._s(_vm.label)+"\n  ")]):_vm._e(),_vm._v(" "),_c('input',_vm._b({staticClass:"form-control border-input",domProps:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input',$event.target.value)}}},'input',_vm.$attrs,false))])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "+m3G":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"loader"}},[_c('p',[_vm._v("Loading...")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/0Ro":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"catalog"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding":"3px"}},[(_vm.showbuttons)?_c('div',{staticClass:"row",staticStyle:{"margin":"0px","position":"fixed","z-index":"9999","background":"white","min-height":"60px","width":"100%","top":"0px","border-bottom":"1px solid #e8e7e3"},attrs:{"id":"static-top"}},[_c('div',{staticStyle:{"margin-top":"15px"}},[(_vm.current_level > 0)?_c('div',{staticClass:"col-xs-2",staticStyle:{"padding-left":"20px","padding-top":"8px"},on:{"click":function($event){return _vm.leveldown()}}},[_vm._m(0)]):_c('div',{staticClass:"col-xs-2",staticStyle:{"padding-left":"20px","padding-top":"8px"}}),_vm._v(" "),_c('div',{staticClass:"col-xs-8",staticStyle:{"padding":"0px"}},[(_vm.searchactive)?_c('div',{attrs:{"ifclass":"col-xs-12"}},[_c('div',{staticClass:"input-group"},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.searchdata),expression:"searchdata"}],staticClass:"form-control",attrs:{"type":"text","value":"","placeholder":"Поиск..."},domProps:{"value":(_vm.searchdata)},on:{"keyup":function($event){return _vm.changesearch()},"input":function($event){if($event.target.composing){ return; }_vm.searchdata=$event.target.value}}}),_vm._v(" "),_c('span',{staticClass:"input-group-addon",on:{"click":function($event){return _vm.changesearchactive(false)}}},[_c('i',{staticClass:"ti-close"})])])]):_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"6px","padding-top":"5px"}},[_c('div',{staticClass:"col-xs-10"},[_c('span',[_vm._v(_vm._s(_vm.parentname))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2",staticStyle:{"font-size":"20px"},on:{"click":function($event){return _vm.changesearchactive(true)}}},[_c('i',{staticClass:"fa fa-search"})])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2",staticStyle:{"padding-left":"6px","padding-top":"4px"}},[(_vm.sum > 0)?_c('span',{staticStyle:{"font-size":"24px"},on:{"click":function($event){return _vm.clear_order()}}},[_c('i',{staticClass:"ti-trash"})]):_vm._e()])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin":"0"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content",staticStyle:{"margin-top":"60px"}},[_c('div',{staticClass:"row",staticStyle:{"font-size":"1.5em"}},[_c('div',{staticClass:"col-xs-4",on:{"click":function($event){return _vm.cheangetype(1)}}},[_c('center',[_c('i',{staticClass:"ti-align-justify"})])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4",on:{"click":function($event){return _vm.cheangetype(2)}}},[_c('center',[_c('i',{staticClass:"ti-layout-accordion-separated"})])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-4",on:{"click":function($event){return _vm.cheangetype(3)}}},[_c('center',[_c('i',{staticClass:"ti-layout-grid2"})])],1)])])])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-bottom":"100px"}},[(_vm.typeview===1)?_c('div',[_vm._l((_vm.goods_arr),function(good){return _c('div',{key:good.id,staticClass:"row",on:{"click":function($event){return _vm.levelup(good)}}},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"padding-left":"15px"},on:{"click":function($event){return _vm.showSwal('input-field', good)}}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.photo_src(good))}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-9",staticStyle:{"padding-left":"5px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-right":"3px","padding-left":"3px"}},[_c('div',{staticClass:"td-name pull-left"},[_vm._v(_vm._s(good.name))])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-xs-6",staticStyle:{"padding-left":"0px","padding-right":"0"}},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('div',{staticClass:"td-sum"},[[_vm._v("\n                                        "+_vm._s(_vm.goodPrice(good))+"\n                                    ")]],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"10px","padding-right":"5px","min-height":"26px"}},[_c('div',{staticClass:"td-order"},[(_vm.order.find(function (x) { return x.good === good.id; }))?[_c('span',{},[_vm._v("х "+_vm._s(_vm.order.find(function (x) { return x.good === good.id; }).quantity)+" "+_vm._s(_vm.koef(good)))])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-10",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"td-order"},[(_vm.order.find(function (x) { return x.good === good.id; }))?void 0:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6",staticStyle:{"padding-left":"0px","padding-right":"0"}},[_c('div',{staticClass:"col-xs-6",staticStyle:{"padding-left":"0px","padding-right":"0"}},[(good.isgroup === 0)?[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.remove_good(good)}}},[_c('i',{staticClass:"ti-minus"})])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-xs-6",staticStyle:{"padding-left":"0px","padding-right":"15px"}},[(good.isgroup === 0)?[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.add_good(good)}}},[_c('i',{staticClass:"ti-plus"})])]:_vm._e()],2)])]),_vm._v(" "),(good.units.length>1)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-right":"3px","padding-left":"3px"}},[_c('drop-down',[_c('button',{staticClass:"btn btn-block dropdown-toggle",attrs:{"slot":"title","data-toggle":"dropdown"},slot:"title"},[_vm._v("\n                                    "+_vm._s(good.units.find(function (unit) { return unit.def === true; }).name)+"\n                                    "),_c('b',{staticClass:"caret"})]),_vm._v(" "),_vm._l((good.units),function(unit){return _c('li',{key:unit.uuid,on:{"click":function($event){return _vm.changeUnit(good, unit)}}},[_c('a',[_vm._v(_vm._s(unit.name))])])})],2),_vm._v(" "),_vm._l((good.units),function(unit){return _c('span',{key:unit.uuid,staticStyle:{"margin-right":"10px"}})})],2)]):_vm._e()])])}),_vm._v(" "),(_vm.loadmore)?_c('p',[_vm._v(" .... 🙄 ...")]):_vm._e()],2):_vm._e(),_vm._v(" "),(_vm.typeview===2)?_c('div',_vm._l((_vm.goods_arr),function(good){return _c('div',{key:good.id,staticClass:"card",staticStyle:{"margin-left":"10px","margin-right":"10px"},on:{"click":function($event){return _vm.levelup(good)}}},[(good.isgroup === 0)?_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.photo_src(good))}})])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-8"},[_vm._v(_vm._s(good.name))]),_vm._v(" "),_c('div',{staticClass:"col-xs-4",staticStyle:{"text-align":"right"}},[(good.price)?[_vm._v("\n                                    "+_vm._s(good.price +  '')+"\n                                ")]:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"col-xs-4"},[(good.isgroup === 0)?[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.remove_good(good)}}},[_c('i',{staticClass:"ti-minus"})])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[(_vm.order.find(function (x) { return x.good === good.id; }))?[_c('span',{},[_vm._v("х "+_vm._s(_vm.order.find(function (x) { return x.good === good.id; }).quantity)+" ")])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-xs-4"},[(good.isgroup === 0)?[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.add_good(good)}}},[_c('i',{staticClass:"ti-plus"})])]:_vm._e()],2)])])]):_c('div',{staticClass:"card-content"},[_c('div',{staticStyle:{"height":"150px","background-color":"#ff7a38","text-align":"center"}},[(good.name.length < 18)?_c('span',{staticStyle:{"font-size":"2.6em","color":"white","font-family":"'Oswald', sans-serif"}},[_vm._v(_vm._s(good.name))]):_c('span',{staticStyle:{"font-size":"2.6em","color":"white","font-family":"'Oswald', sans-serif"}},[_vm._v(_vm._s(good.name))])])])])}),0):_vm._e(),_vm._v(" "),(_vm.typeview===3)?_c('div',_vm._l((_vm.goods_arr),function(good){return _c('div',{key:good.id,staticClass:"col-xs-6",staticStyle:{"padding":"2px"},on:{"click":function($event){return _vm.levelup(good)}}},[_c('div',{staticClass:"card",on:{"click":function($event){return _vm.showSwal('input-field', good)}}},[_c('div',{staticClass:"card-content",staticStyle:{"padding":"4px"}},[(good.isgroup === 0)?_c('div',{staticClass:"card-content",staticStyle:{"padding":"2px"}},[_c('span',{domProps:{"innerHTML":_vm._s(_vm.photo_src(good))}})]):_c('div',{staticClass:"card-content",staticStyle:{"padding":"2px"}},[_c('div',{staticStyle:{"height":"100px","background-color":"#ff7a38","text-align":"center","vertical-align":"middle","font-family":"'Oswald', sans-serif"}},[(good.name.length < 20)?_c('span',{staticStyle:{"color":"white","font-weight":"700","font-size":"25px"}},[_vm._v(_vm._s(good.name))]):_c('span',{staticStyle:{"color":"white","font-weight":"700","font-size":"23px"}},[_vm._v(_vm._s(good.name))])])])])])])}),0):_vm._e()]),_vm._v(" "),(_vm.showbuttons&&_vm.sum>0)?_c('div',{staticClass:"row",staticStyle:{"position":"fixed","z-index":"9990","background":"white","min-height":"0px","bottom":"0px","width":"100%"},attrs:{"id":"static-order"}},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"4%","padding-bottom":"10px"}},[_c('router-link',{attrs:{"to":"/order"}},[_c('button',{staticClass:"btn btn-warning btn-fill btn-wd",staticStyle:{"height":"60px","width":"100%"},on:{"click":function($event){}}},[_c('span',{staticClass:"center",staticStyle:{"padding-left":"60px"}},[_vm._v("Корзина")]),_c('span',{staticClass:"pull-right"},[_vm._v(_vm._s(_vm.sum))])])])],1)]):_vm._e(),_vm._v(" "),(_vm.showbuttons&&_vm.sum<=0)?_c('div',{staticClass:"row",staticStyle:{"position":"fixed","z-index":"9990","background":"rgba(4,7,6,0.27)","height":"60px","bottom":"0px","width":"100%"},attrs:{"id":"menu"}},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"4%","padding":"0px","border-top":"1px ridge rgba(4,7,6,0.16)"}},[_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"#ececec","padding":"10px"}},[_c('router-link',{attrs:{"to":"/catalog"}},[_c('center',[_c('i',{staticClass:"ti-agenda",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Каталог")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/order"}},[_c('center',[_c('i',{staticClass:"ti-shopping-cart",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Заказ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/orderslist"}},[_c('center',[_c('i',{staticClass:"ti-timer",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("История")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/settings"}},[_c('center',[_c('i',{staticClass:"ti-more-alt",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Ещё")])])],1)],1)])]):_vm._e()])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticStyle:{"font-size":"20px"}},[_c('i',{staticClass:"ti-arrow-left"})])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "/yTY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__ = __webpack_require__("XXRA");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3246158d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__ = __webpack_require__("hdUz");
function injectStyle (ssrContext) {
  __webpack_require__("2RMm")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-3246158d"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Order_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_3246158d_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Order_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "0XqQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'stats-card'
});

/***/ }),

/***/ "0tpD":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"showorder"}},[(_vm.order.length>0)?_c('div',{staticClass:"col-md-5",staticStyle:{"margin-right":"0","margin-left":"0","top":"10px"}},[_vm._l((_vm.order[0].goods),function(good){return _c('div',{key:good.good,staticClass:"row"},[_c('hr',{staticStyle:{"margin":"10px"}}),_vm._v(" "),_c('div',{staticClass:"col-xs-2",staticStyle:{"padding-left":"10px","text-align":"right"}},[_vm._v("\n                            "+_vm._s(good.quantity * good.multiplier)+"\n                        ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-7",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_vm._v("\n                                    "+_vm._s('x ' +good.name)+"\n                                ")])])]),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"text-align":"right"}},[_vm._v("\n                            "+_vm._s(Math.floor(good.price * good.quantity * 100 * good.multiplier) / 100)+" p.\n                        ")])])}),_vm._v(" "),_c('div',[_c('hr'),_vm._v(" "),_c('center',[_c('button',{staticClass:"btn btn-wd btn-info",attrs:{"type":"button"},on:{"click":function($event){return _vm.copyorder(_vm.order[0].goods)}}},[_c('span',{staticClass:"btn-label"},[_c('i',{staticClass:"fa fa-check"})]),_vm._v("\n                    Копировать\n                ")])]),_vm._v(" "),_c('br')],1)],2):_vm._e()])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "1Kqs":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-radio',
  model: {
    prop: 'value'
  },
  props: {
    label: [String, Number],
    disabled: [Boolean, String],
    value: [String, Boolean],
    inline: Boolean,
    type: {
      type: String,
      default: 'neutral'
    }
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.value;
      },
      set: function set(value) {
        this.$emit('input', value);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'radio-inline';
      }
      return '';
    },
    radioClasses: function radioClasses() {
      return 'radio-' + this.type + ' ' + this.inlineClass;
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "2RMm":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "5FAv":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__ = __webpack_require__("eAxr");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__ = __webpack_require__("gKTg");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_NotFoundPage_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_d9cef132_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_NotFoundPage_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "5N/K":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Settings'
});

/***/ }),

/***/ "7Yqs":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7dPz":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "7mvM":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowOrder_vue__ = __webpack_require__("ANbf");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a08f580_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowOrder_vue__ = __webpack_require__("0tpD");
function injectStyle (ssrContext) {
  __webpack_require__("+11S")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7a08f580"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_ShowOrder_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7a08f580_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_ShowOrder_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "9G8F":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ANbf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'ShowOrder',
  props: ['order_uuid'],
  data: function data() {
    return {
      order: []
    };
  },
  mounted: function mounted() {
    this.get_order();
  },

  methods: {
    get_order: function get_order() {
      var _this = this;

      this.$db.orders.where({ 'id': this.order_uuid }).toArray().then(function (x) {
        return _this.order = x;
      });
    },
    date_format: function date_format(dt) {
      var d = new Date(dt);

      return d.toLocaleString('ru-RU');
    },
    copyorder: function copyorder(goods) {
      this.$db.order.bulkPut(goods).then(this.$router.push({ name: 'Order' }));
    }
  }
});

/***/ }),

/***/ "AuCi":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "C79p":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoodsList_vue__ = __webpack_require__("Tq9h");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2797f3de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoodsList_vue__ = __webpack_require__("qXdX");
function injectStyle (ssrContext) {
  __webpack_require__("XjMg")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2797f3de"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_GoodsList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2797f3de_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_GoodsList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Crv8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__ = __webpack_require__("R5Ta");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__ = __webpack_require__("HRUz");



var SidebarStore = {
  showSidebar: false,
  sidebarLinks: [],
  isMinimized: false,
  displaySidebar: function displaySidebar(value) {
    this.showSidebar = value;
  },
  toggleMinimize: function toggleMinimize() {
    document.body.classList.toggle('sidebar-mini');

    var simulateWindowResize = setInterval(function () {
      window.dispatchEvent(new Event('resize'));
    }, 180);

    setTimeout(function () {
      clearInterval(simulateWindowResize);
    }, 1000);

    this.isMinimized = !this.isMinimized;
  }
};

var SidebarPlugin = {
  install: function install(Vue, options) {
    if (options && options.sidebarLinks) {
      SidebarStore.sidebarLinks = options.sidebarLinks;
    }
    Vue.mixin({
      data: function data() {
        return {
          sidebarStore: SidebarStore
        };
      }
    });

    Object.defineProperty(Vue.prototype, '$sidebar', {
      get: function get() {
        return this.$root.sidebarStore;
      }
    });
    Vue.component('side-bar', __WEBPACK_IMPORTED_MODULE_0__SideBar_vue__["a" /* default */]);
    Vue.component('sidebar-item', __WEBPACK_IMPORTED_MODULE_1__SidebarItem_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (SidebarPlugin);

/***/ }),

/***/ "FiZY":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony default export */ __webpack_exports__["a"] = ([{
  name: 'Dashboard',
  icon: 'ti-panel',
  collapsed: false,
  children: [{
    name: 'Overview',
    path: '/admin/overview'
  }, {
    name: 'Stats',
    path: '/admin/stats'
  }]
}, {
  name: 'Components',
  icon: 'ti-package',
  children: [{
    name: 'Buttons',
    path: '/components/buttons'
  }, {
    name: 'Grid System',
    path: '/components/grid-system'
  }, {
    name: 'Panels',
    path: '/components/panels'
  }, {
    name: 'Sweet Alert',
    path: '/components/sweet-alert'
  }, {
    name: 'Notifications',
    path: '/components/notifications'
  }, {
    name: 'Icons',
    path: '/components/icons'
  }, {
    name: 'Typography',
    path: '/components/typography'
  }]
}, {
  name: 'Forms',
  icon: 'ti-clipboard',
  children: [{
    name: 'Regular Forms',
    path: '/forms/regular'
  }, {
    name: 'Extended Forms',
    path: '/forms/extended'
  }, {
    name: 'Validation Forms',
    path: '/forms/validation'
  }, {
    name: 'Wizard',
    path: '/forms/wizard'
  }]
}, {
  name: 'Table List',
  icon: 'ti-view-list-alt',
  collapsed: true,
  children: [{
    name: 'Regular Tables',
    path: '/table-list/regular'
  }, {
    name: 'Extended Tables',
    path: '/table-list/extended'
  }, {
    name: 'Paginated Tables',
    path: '/table-list/paginated'
  }]
}, {
  name: 'Maps',
  icon: 'ti-map',
  children: [{
    name: 'Google Maps',
    path: '/maps/google'
  }, {
    name: 'Full Screen Maps',
    path: '/maps/full-screen'
  }, {
    name: 'Vector Maps',
    path: '/maps/vector-map'
  }]
}, {
  name: 'Charts',
  icon: 'ti-gift',
  path: '/charts'
}, {
  name: 'Calendar',
  icon: 'ti-calendar',
  path: '/calendar'
}, {
  name: 'Pages',
  icon: 'ti-gift',
  children: [{
    name: 'User Page',
    path: '/pages/user'
  }, {
    name: 'Timeline Page',
    path: '/pages/timeline'
  }, {
    name: 'Login Page',
    path: '/login'
  }, {
    name: 'Register Page',
    path: '/register'
  }, {
    name: 'Lock Page',
    path: '/lock'
  }]
}]);

/***/ }),

/***/ "GJqE":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"n-radio radio",class:_vm.radioClasses},[_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.model),expression:"model"}],attrs:{"id":_vm.cbId,"type":"radio","disabled":_vm.disabled},domProps:{"value":_vm.label,"checked":_vm._q(_vm.model,_vm.label)},on:{"change":function($event){_vm.model=_vm.label}}}),_vm._v(" "),_c('label',{attrs:{"for":_vm.cbId}},[_vm._t("default")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "HRUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__ = __webpack_require__("zwtn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4773f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__ = __webpack_require__("MGBx");
function injectStyle (ssrContext) {
  __webpack_require__("Wdwa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SidebarItem_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_4d4773f3_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SidebarItem_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "I7Q5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Custom_LoaderCustom__ = __webpack_require__("VHDh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GoodsList__ = __webpack_require__("C79p");







if (!Date.now) {
  Date.now = function () {
    return new Date().getTime();
  };
}

function sortirovka(arr) {
  arr.sort(function (a, b) {
    var nameA = a.name.toLowerCase();
    var nameB = b.name.toLowerCase();
    if (nameA < nameB) {
      return -1;
    }
    if (nameA > nameB) {
      return 1;
    }
    return 0;
  });
  arr.sort(function (a, b) {
    var nameA = a.isgroup;
    var nameB = b.isgroup;
    if (nameA < nameB) {
      return 1;
    }
    if (nameA > nameB) {
      return -1;
    }
    return 0;
  });
  return arr;
}
function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
}

/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    loader: __WEBPACK_IMPORTED_MODULE_2_src_components_UIComponents_Custom_LoaderCustom__["a" /* default */],
    GoodsList: __WEBPACK_IMPORTED_MODULE_3__GoodsList__["a" /* default */]
  },
  name: 'Catalog',
  data: function data() {
    return {
      demo: true,
      timestamp: '',
      searchactive: false,
      typeview: 1,
      showbuttons: true,
      searchdata: '',
      message: '',
      loader: false,
      breadcrumb_arr: [{ 'id': 0, 'name': 'Каталог товаров', 'islevel': 1 }],
      goods_arr: [],
      goods_arr2: [],
      current_level: 0,
      current_parent: [],
      parentname: 'Каталог товаров',
      order: [],
      sum: 0,
      i: 0,
      link: 'https://images.akitorg.ru/images/',
      order_tap: false,
      classPhoto: 'col-xs-3',
      scrollposition: 0,
      scrollpositionold: 0,
      goods: [],
      counter: 19,
      loadmore: false,
      distr: null
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (localStorage.getItem('curentDist')) {
      this.distr = localStorage.getItem('curentDist');
    } else {
      this.$db.settings.toArray().then(function (x) {
        if (x.length > 0) {
          _this.distr = x[0].dbase;
          localStorage.curentDist = x[0].dbase;
        }
      });
    }
    this.check_demo();
    this.auto_obmen();
    this.getphotolink();
    this.load_save_order();
    this.get_goods();

    window.addEventListener('scroll', function () {
      _this.scrollposition = pageYOffset;
    });
  },

  methods: {
    auto_obmen: function auto_obmen() {
      var _this2 = this;

      this.$db.settings.toArray().then(function (set) {
        var now = Date.now();
        var dif = now - set[0].lastconnection;
        if (dif > 1800000) {
          _this2.$router.push({ name: 'Obmen' });
        }
      });
    },
    check_demo: function check_demo() {
      var _this3 = this;

      this.$db.settings.toArray().then(function (set) {
        if (set[0].dbase === '1389') {
          _this3.demo = true;
        }
      });
    },
    log: function log(p) {
      console.log(p);
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(resolve, ms);
      });
    },
    getphotolink: function getphotolink() {
      var _this4 = this;

      this.$db.settings.where({ 'dbase': this.distr }).toArray().then(function (x) {
        if (x.length !== 0) {
          _this4.link = _this4.link + x[0].regcode + '/goods_photos/';
        }
      }).catch(function (e) {
        console.log(e);
        _this4.message = e;
      });
    },
    parent_name: function parent_name(name) {
      if (name.length > 20) {
        this.parentname = name.slice(0, 20) + '...';
      } else {
        this.parentname = name;
      }
    },
    changesearchactive: function changesearchactive(p) {
      this.searchactive = p;
      if (!p) {
        this.searchgoods('');
      }
    },
    cheangetype: function cheangetype(type) {
      this.typeview = type;
    },
    searchgoods: function searchgoods(search) {
      var _this5 = this;

      if (search.length === 0) {
        this.current_level = 1;
        this.current_parent = [];
        this.get_goods(0);
        return;
      }
      this.$db.goods.filter(function (good) {
        var gn = good.name.toLowerCase();
        var s = search.toLowerCase();
        if (gn.indexOf(s) + 1) {
          return true;
        } else {
          return false;
        }
      }).toArray().then(function (t) {
        _this5.search_final(t);
      });
    },
    search_final: function search_final(t) {
      this.goods = [];
      this.goods = sortirovka(t);
      this.correctUnits(this.goods);
      this.current_level = 0;
      this.counter = 0;
      this.addtolist(20);
    },
    changesearch: function changesearch() {
      console.log(this.searchdata);
      this.searchgoods(this.searchdata);
    },
    levelup: function levelup(good) {
      if (!good.isgroup) {
        return;
      }
      this.get_goods(good.id);
      this.current_parent.push(good);
      this.parent_name(good.name);
      this.current_level++;
    },
    leveldown: function leveldown() {
      var parent = this.current_parent.pop();
      this.current_level--;
      if (this.current_level === 0) {
        this.get_goods(0);
        this.parentname = 'Каталог товаров';
        this.current_parent.pop();
      } else {
        this.get_goods(parent.parent);
        this.parent_name(this.current_parent[this.current_parent.length - 1].name);
      }
    },
    addtolist: function addtolist(count) {
      console.log('count= ' + count);
      if (this.counter === 0) {
        this.goods_arr = [];
      }
      var a = true;
      var goodsnoview = this.goods.length - this.counter;
      if (goodsnoview <= count) {
        count = goodsnoview;
        a = false;
      }
      for (var i = 0; i < count; i++) {
        this.goods_arr.push(this.goods[this.counter]);
        this.counter++;
        this.loadmore = a;
      }
      console.log('++++++++++++++++++++++++addtolist');
      console.log(this.goods_arr);
      console.log('addtolist ________________________');
    },
    get_goods: function get_goods(parent) {
      var _this6 = this;

      var vm = this;
      if (!parent) {

        this.$db.goods.where({ 'parent': 0 }).toArray().then(function (goods) {
          if (goods.length === 0) {
            _this6.$db.goods.where({ 'islevel': 1 }).toArray().then(function (goods2) {
              if (goods2.length !== 0) {
                vm.goods = sortirovka(goods2);
                _this6.current_level = 0;
                _this6.counter = 0;
                _this6.addtolist(20);
              }
            });
          } else {
            vm.goods = sortirovka(goods);
            vm.correctUnits(vm.goods);
            _this6.current_level = 0;
            _this6.counter = 0;
            _this6.addtolist(20);
          }
        }).catch(function (error) {
          console.log('кетч33');
          console.log(error);
          if (error.response) {
            _this6.message = error.response.data + error.response.status + error.response.headers;
          }
        }).finally(function (r) {});
      } else {
        this.$db.goods.where({ 'parent': parent }).toArray().then(function (goods) {
          _this6.counter = 0;
          _this6.goods = sortirovka(goods);
          vm.correctUnits(vm.goods);
          _this6.addtolist(20);
        }).catch(function (error) {
          _this6.message = 'кетч33';
          if (error.response) {
            _this6.message = error.response.data + error.response.status + error.response.headers;
          }
        });
      }
    },
    load_save_order: function load_save_order() {
      var _this7 = this;

      var p = this.$db.order.toArray();
      p.then(function (x) {
        _this7.order = x;
        _this7.order_sum();
      });
    },
    add_good: function add_good(good) {
      var quantity = 1;
      var unit = good.units.find(function (unit) {
        return unit.def === true;
      });
      if (unit === undefined) {
        if (good.units.length === 1) {
          unit = good.units[0];
        }
      }

      var a = this.order.findIndex(function (x) {
        return x.good === good.id;
      });

      if (a >= 0) {
        quantity = this.order[a].quantity;
        quantity++;
        var vdsum = Math.floor(quantity * good.price * 100 * unit.multiplier) / 100;
        this.$set(this.order, a, { good: good.id, quantity: quantity, price: good.price, name: good.name, photo: good.photo, unit: unit.id, dsum: vdsum, multiplier: unit.multiplier, discount: 0, project: 0, info: '' });
      } else {
        this.order.push({ good: good.id, quantity: quantity, price: good.price, name: good.name, photo: good.photo, unit: unit.id, dsum: good.price, multiplier: unit.multiplier, discount: 0, project: 0, info: '' });
      }
      this.$db.order.bulkPut(this.order);
      this.order_sum();
    },
    set_q: function set_q(good, q) {
      var dsum = Math.floor(q * good.price * 100) / 100;
      var b = this.order.findIndex(function (x) {
        return x.good === good.id;
      });
      if (b >= 0) {
        this.$set(this.order, b, { good: good.id, quantity: q, price: good.price, name: good.name, photo: good.photo, unit: 0, dsum: dsum, multiplier: 1, discount: 0, project: 0, info: '' });
      } else {
        this.order.push({ good: good.id, quantity: q, price: good.price, name: good.name, photo: good.photo, unit: 0, dsum: dsum, multiplier: 1, discount: 0, project: 0, info: '' });
      }
      this.$db.order.bulkPut(this.order);
      this.order_sum();
    },
    remove_good: function remove_good(good) {
      var unit = good.units.find(function (unit) {
        return unit.def === true;
      });
      if (unit === undefined) {
        if (good.units.length === 1) {
          unit = good.units[0];
        }
      }

      var a = this.order.findIndex(function (x) {
        return x.good === good.id;
      });
      if (a >= 0) {
        var quantity = this.order[a].quantity;
        if (quantity > 1) {
          quantity--;
          var vdsum = Math.floor(quantity * good.price * 100 * unit.multiplier) / 100;
          this.$set(this.order, a, { good: good.id, quantity: quantity, price: good.price, name: good.name, photo: good.photo, unit: unit.id, dsum: vdsum, multiplier: unit.multiplier, discount: 0, project: 0, info: '' });
        } else {
          this.order.splice(a, 1);
          this.$db.order.where('good').equals(good.id).delete();
        }
      } else {
        return;
      }
      this.$db.order.bulkPut(this.order);
      this.order_sum();
    },
    order_sum: function order_sum() {
      var itog = 0;
      this.order.forEach(function (item) {
        itog = itog + item.price * item.quantity * item.multiplier;
      });
      itog = Math.floor(itog * 100) / 100;
      this.sum = itog;
      return itog;
    },
    sumrow: function sumrow(goodid) {
      return Math.floor(this.order.find(function (x) {
        return x.good === goodid;
      }).quantity * this.order.find(function (x) {
        return x.good === goodid;
      }).price * 100) / 100;
    },

    refresh: function refresh() {
      this.get_goods(this.current_level);
    },
    photo_src: function photo_src(good) {
      if (good.isgroup) {
        this.classPhoto = 'col-xs-2';
        return '<i class="ti-folder" style="font-size:2.3rem;"></i>';
      } else if (good.photo != '' & good.photo.length > 4) {
        this.classPhoto = 'col-xs-3';
        return '<img src="' + this.link + good.photo + '" alt="..." width="100%" height="100%"/><span style="min-height: 90px;width: 1px;"></span>';
      } else {
        if (this.typeview === 1) {
          return '<i class="ti-image" style="font-size:4rem;"></i><span style="min-height: 90px;width: 1px;"></span>';
        }
        if (this.typeview === 2) {
          return '<div style="height:150px;background-color:rgba(0,206,86,0.84);text-align: center;font-family: \'Oswald\', sans-serif;">' + '<span style="font-size: 1.6em; color: white;" >' + good.name + '</span>' + '</div>';
        }
        if (this.typeview === 3) {
          return '<div style="height:100px;background-color:rgba(0,206,86,0.84);text-align: center;vertical-align: middle;font-family: \'Oswald\', sans-serif;">' + '<span style="font-size: 1.2em; color: white;" >' + good.name + '</span>' + '</div>';
        }
      }
    },
    getSummaries: function getSummaries(param) {
      var _this8 = this;

      var columns = param.columns;

      var sums = [];
      columns.forEach(function (column, index) {
        if (index === 0) {
          sums[index] = 'Total';
        } else if (index < columns.length - 1) {
          sums[index] = '';
        } else {
          var sum = 0;
          _this8.productsTable.forEach(function (obj) {
            sum += obj.quantity * obj.price;
          });
          sums[index] = '\u20AC ' + sum;
        }
      });
      return sums;
    },
    showSwal: function showSwal(type, good) {
      var _this9 = this;

      if (good.isgroup) {
        return;
      }

      var quantity = 0;
      var photo = '';
      if (this.order.find(function (x) {
        return x.good === good.id;
      }) === undefined) {
        quantity = '';
      } else {
        quantity = this.order.find(function (x) {
          return x.good === good.id;
        }).quantity;
      }
      if (good.photo !== '' && good.photo.length > 4) {
        photo = '<img src="' + this.link + good.photo + '" alt="..." style="width: 80%; height: 80%;">';
      } else {}
      this.showbuttons = false;
      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        backdrop: false,
        title: good.name,
        html: '<div class="form-group">' + photo + '<p>' + good.price + '' + '</p>' + '</div>',
        input: 'number',
        inputValue: quantity,
        inputPlaceholder: 'Введите количество',
        showCloseButton: true
      }).then(function (result) {
        if (result > 0) {
          _this9.set_q(good, result);
        } else if (result === '0' | result === '') {
          _this9.dellgood(good.id);
        }
      }).catch(function (x) {}).finally(function (x) {
        _this9.showbuttons = true;
      });
    },
    dellgood: function dellgood(goodid) {
      var a = this.order.findIndex(function (x) {
        return x.good === goodid;
      });

      this.order.splice(a, 1);
      this.$db.order.where('good').equals(goodid).delete();
      this.order_sum();
    },
    clear_order: function clear_order() {
      var _this10 = this;

      this.currentGoodUnit = { 'good': 0, 'unit': 0 };

      __WEBPACK_IMPORTED_MODULE_1_sweetalert2___default()({
        title: 'Точно удалить весь заказ?',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      }).then(function (result) {
        if (result) {
          _this10.order = [];
          _this10.$db.order.clear();
          _this10.order_sum();
          _this10.order_tap = false;
        }
      }).catch(function (error) {});
    },
    show_order: function show_order() {
      this.order_tap = true;
    },
    correctUnits: function correctUnits(goods) {
      var _this11 = this;

      var _loop = function _loop(i) {
        for (var a = 0; a < goods[i].units.length; a++) {
          goods[i].units[a].uuid = uuidv4();
          goods[i].units[a].def = false;
          if (_this11.order.find(function (item) {
            return item.good === goods[i].id;
          })) {
            var orderUnitId = _this11.order.find(function (item) {
              return item.good === goods[i].id;
            }).unit;
            if (goods[i].units[a].id === orderUnitId) {
              goods[i].units[a].def = true;
            }
          } else {
            if (goods[i].units[a].id === 0) {
              goods[i].units[a].def = true;
            }
          }
        }
      };

      for (var i = 0; i < goods.length; i++) {
        _loop(i);
      }
    },
    changeUnit: function changeUnit(good, unit) {
      for (var i = 0; i < good.units.length; i++) {
        if (good.units[i].id === unit.id) {
          good.units[i].def = true;
        } else {
          good.units[i].def = false;
        }
        good.units[i].uuid = uuidv4();
      }
      this.$forceUpdate();
      var a = this.order.findIndex(function (x) {
        return x.good === good.id;
      });
      if (a >= 0) {
        var quantity = this.order[a].quantity;
        var vdsum = Math.floor(quantity * good.price * 100 * unit.multiplier) / 100;
        this.$set(this.order, a, { good: good.id, quantity: quantity, price: good.price, name: good.name, photo: good.photo, unit: unit.id, dsum: vdsum, multiplier: unit.multiplier, discount: 0, project: 0, info: '' });
        this.$db.order.bulkPut(this.order);
      }
      this.order_sum();
    },
    goodPrice: function goodPrice(good) {
      if (good.isgroup === 1) {
        return '';
      }
      var price = good.price;
      for (var i = 0; i < good.units.length; i++) {
        if (good.units[i].def === true) {
          price = Math.round(good.units[i].multiplier * good.price * 100) / 100;
        }
      }
      return price;
    },
    koef: function koef(good) {
      var r = 1;
      if (good.units.length > 1) {
        r = good.units.find(function (unit) {
          return unit.def === true;
        }).multiplier;
      }

      if (good.units.length === 1) {
        r = good.units[0].multiplier;
      }

      if (r !== 1) {
        return '(x' + r + ')';
      } else {
        return '';
      }
    }
  },
  watch: {
    scrollposition: function scrollposition() {
      if (this.scrollposition - this.scrollpositionold > 10) {
        this.addtolist(10);
      }
    }
  } });

/***/ }),

/***/ "JpZU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('notifications',{attrs:{"transition-name":"notification-list","transition-mode":"in-out"}}),_vm._v(" "),_c('transition',{attrs:{"name":"fade","mode":"out-in"}},[_c('router-view')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "KqLX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersList_vue__ = __webpack_require__("mMtV");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7e1f520_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersList_vue__ = __webpack_require__("Whb+");
function injectStyle (ssrContext) {
  __webpack_require__("dctX")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-b7e1f520"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrdersList_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_b7e1f520_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrdersList_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "M93x":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__ = __webpack_require__("xJD8");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0793a4a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__ = __webpack_require__("JpZU");
function injectStyle (ssrContext) {
  __webpack_require__("7Yqs")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_App_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0793a4a6_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_App_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "MAOu":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "MGBx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.baseComponent,{tag:"component",class:{active: _vm.isActive || _vm.$route.fullPath.startsWith(_vm.link.path)},attrs:{"to":_vm.link.path ? _vm.link.path : '/',"tag":"li"}},[(_vm.isMenu)?_c('a',{attrs:{"data-toggle":"collapse","href":"javascript:void(0)"},on:{"click":_vm.collapseMenu}},[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name)+"\n      "),_c('b',{staticClass:"caret"})])]):_vm._e(),_vm._v(" "),(_vm.$slots.default || this.isMenu)?_c('div',[_c('el-collapse-transition',[_c('ul',{directives:[{name:"show",rawName:"v-show",value:(!_vm.collapsed),expression:"!collapsed"}],staticClass:"nav"},[_vm._t("default")],2)])],1):_vm._e(),_vm._v(" "),(_vm.children.length === 0 && !_vm.$slots.default && _vm.link.path)?_vm._t("title",[_c(_vm.elementType(_vm.link, false),{tag:"component",class:{active: _vm.link.active},attrs:{"to":_vm.link.path,"target":_vm.link.target,"href":_vm.link.path}},[(_vm.addLink)?[_c('span',{staticClass:"sidebar-mini"},[_vm._v(_vm._s(_vm.link.name.substring(0, 1)))]),_vm._v(" "),_c('span',{staticClass:"sidebar-normal"},[_vm._v(_vm._s(_vm.link.name))])]:[_c('i',{class:_vm.link.icon}),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.link.name))])]],2)]):_vm._e()],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Mca5":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__("Xxa5");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__ = __webpack_require__("exGp");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator__);




/* harmony default export */ __webpack_exports__["a"] = ({
  props: {
    title: {
      type: String,
      default: 'Paper Dashboard Pro'
    },
    type: {
      type: String,
      default: 'sidebar',
      validator: function validator(value) {
        var acceptedValues = ['sidebar', 'navbar'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    backgroundColor: {
      type: String,
      default: 'black',
      validator: function validator(value) {
        var acceptedValues = ['white', 'brown', 'black'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    activeColor: {
      type: String,
      default: 'success',
      validator: function validator(value) {
        var acceptedValues = ['primary', 'info', 'success', 'warning', 'danger'];
        return acceptedValues.indexOf(value) !== -1;
      }
    },
    logo: {
      type: String,
      default: 'static/img/vue-logo.png'
    },
    sidebarLinks: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    sidebarClasses: function sidebarClasses() {
      if (this.type === 'sidebar') {
        return 'sidebar';
      } else {
        return 'collapse navbar-collapse off-canvas-sidebar';
      }
    },
    navClasses: function navClasses() {
      if (this.type === 'sidebar') {
        return 'nav';
      } else {
        return 'nav navbar-nav';
      }
    }
  },
  methods: {
    initScrollBarAsync: function initScrollBarAsync() {
      var _this = this;

      return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_asyncToGenerator___default()(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee() {
        var PerfectScroll;
        return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _context.next = 2;
                return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, "ieps"));

              case 2:
                _context.next = 4;
                return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, "Fiov"));

              case 4:
                PerfectScroll = _context.sent;

                PerfectScroll.initialize(_this.$refs.sidebarScrollArea);

              case 6:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }))();
    }
  },
  mounted: function mounted() {
    this.initScrollBarAsync();
  },
  beforeDestroy: function beforeDestroy() {
    if (this.$sidebar.showSidebar) {
      this.$sidebar.showSidebar = false;
    }
  }
});

/***/ }),

/***/ "NHnr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue__ = __webpack_require__("I3G/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_vue___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_vue__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_idb__ = __webpack_require__("mmfr");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_vue_idb___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_vue_idb__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__pollyfills__ = __webpack_require__("im4J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_vue_router__ = __webpack_require__("/ocq");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifyjs__ = __webpack_require__("1SRG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifyjs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifyjs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__App_vue__ = __webpack_require__("M93x");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__gloablComponents__ = __webpack_require__("iXuc");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__globalDirectives__ = __webpack_require__("+KYZ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UIComponents_SidebarPlugin__ = __webpack_require__("Crv8");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__routes_routes__ = __webpack_require__("T1vP");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_sass_paper_dashboard_scss__ = __webpack_require__("MAOu");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__assets_sass_paper_dashboard_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__assets_sass_paper_dashboard_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_sass_element_variables_scss__ = __webpack_require__("yv97");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__assets_sass_element_variables_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__assets_sass_element_variables_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_sass_demo_scss__ = __webpack_require__("9G8F");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__assets_sass_demo_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__assets_sass_demo_scss__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__sidebarLinks__ = __webpack_require__("FiZY");




















__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_1_vue_idb___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_7__globalDirectives__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_6__gloablComponents__["a" /* default */]);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_4_vue_notifyjs___default.a);
__WEBPACK_IMPORTED_MODULE_0_vue___default.a.use(__WEBPACK_IMPORTED_MODULE_8__components_UIComponents_SidebarPlugin__["a" /* default */], { sidebarLinks: __WEBPACK_IMPORTED_MODULE_13__sidebarLinks__["a" /* default */] });


window.dibutor = 5;

var router = new __WEBPACK_IMPORTED_MODULE_3_vue_router__["a" /* default */]({
  routes: __WEBPACK_IMPORTED_MODULE_9__routes_routes__["a" /* default */],
  linkActiveClass: 'active'
});

/* harmony default export */ __webpack_exports__["default"] = (new __WEBPACK_IMPORTED_MODULE_1_vue_idb___default.a({
  version: 4,
  database: 'webzakaz',
  schemas: [{ goods: '++, id, price, name, isgroup, parent, islevel, unitname, photo, v3, distr' }, { order: 'good, quantity, price, name, photo, unit, dsum, multiplier, discount, project, info, distr' }, { orders: '++id, uuid, goods, sum, dt, status, info, distr' }, { settings: 'token, dbase, regcode, lastconnection, inn, phone, address, info, сurent_dst, client_extid, firm_name' }, { distributors: '++id, name, token, dbase, regcode' }]
}));

new __WEBPACK_IMPORTED_MODULE_0_vue___default.a({
  el: '#app',
  render: function render(h) {
    return h(__WEBPACK_IMPORTED_MODULE_5__App_vue__["a" /* default */]);
  },
  router: router
});

/***/ }),

/***/ "NfYk":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"obmen"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Обновление каталога продукции")]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(_vm.message))])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticStyle:{"height":"100px"}},[(_vm.l)?_c('div',[_c('center',[_c('span',{domProps:{"innerHTML":_vm._s(_vm.l)}})])],1):_vm._e()]),_vm._v(" "),_c('center',[(!_vm.disable)?_c('button',{staticClass:"btn btn-danger",on:{"click":_vm.get_goods}},[_vm._v("Обновить каталог")]):_vm._e()]),_vm._v(" "),(_vm.loader)?_c('loader'):_vm._e()],1)])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"position":"fixed","z-index":"9990","background":"rgba(4,7,6,0.27)","height":"60px","bottom":"0px","width":"100%"},attrs:{"id":"menu"}},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"4%","padding":"0px","border-top":"1px ridge rgba(4,7,6,0.16)"}},[_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/catalog"}},[_c('center',[_c('i',{staticClass:"ti-agenda",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Каталог")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/order"}},[_c('center',[_c('i',{staticClass:"ti-shopping-cart",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Заказ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/orderslist"}},[_c('center',[_c('i',{staticClass:"ti-timer",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("История")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"#ececec","padding":"10px"}},[_c('router-link',{attrs:{"to":"/settings"}},[_c('center',[_c('i',{staticClass:"ti-more-alt",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Ещё")])])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Ohs0":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Catalog_vue__ = __webpack_require__("I7Q5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e9b08c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Catalog_vue__ = __webpack_require__("/0Ro");
function injectStyle (ssrContext) {
  __webpack_require__("7dPz")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-43e9b08c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Catalog_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_43e9b08c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Catalog_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "Ond/":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__ = __webpack_require__("eU1q");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__ = __webpack_require__("+lQa");
function injectStyle (ssrContext) {
  __webpack_require__("AuCi")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_formGroupInput_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7d63ebd4_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_formGroupInput_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "PbAS":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderInfo_vue__ = __webpack_require__("VwNU");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2191757e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderInfo_vue__ = __webpack_require__("ilcf");
function injectStyle (ssrContext) {
  __webpack_require__("l1vO")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-2191757e"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_OrderInfo_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2191757e_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_OrderInfo_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QOVQ":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__ = __webpack_require__("5N/K");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_139bdb12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__ = __webpack_require__("TLj+");
function injectStyle (ssrContext) {
  __webpack_require__("hxRq")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-139bdb12"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Settings_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_139bdb12_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Settings_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "QzOK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_sweetalert2__);




/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'First',
  data: function data() {
    return {
      distr: null,
      newDistr: null,
      curentDist: null
    };
  },
  mounted: function mounted() {
    this.curentDist = localStorage.getItem('curentDist');

    this.loadDistr();
  },

  methods: {
    loadDistr: function loadDistr() {
      var _this = this;

      this.$db.distributors.toArray().then(function (x) {
        _this.distr = x;
      });
    },
    selectedDistr: function selectedDistr() {
      this.$db.order.clear();
      localStorage.curentDist = this.newDistr;
      this.$router.push({ name: 'Obmen' });
    },
    dellDistr: function dellDistr(dbase) {
      var _this2 = this;

      __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
        title: 'Удалить поставщика??',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false }).then(function (result) {
        if (result) {
          _this2.$db.distributors.where('dbase').equals(dbase).delete();
          _this2.$router.push({ name: 'first' });
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    dellOrder: function dellOrder(dbase) {
      var _this3 = this;

      if (dbase !== this.curentDist) {
        this.newDistr = dbase;
        this.$db.order.toArray().then(function (x) {
          if (x.length > 0) {
            __WEBPACK_IMPORTED_MODULE_0_sweetalert2___default()({
              title: 'Удалить неотправленный заказ?',
              showCancelButton: true,
              confirmButtonClass: 'btn btn-success btn-fill',
              cancelButtonClass: 'btn btn-danger btn-fill',
              buttonsStyling: false
            }).then(function (result) {
              if (result) {
                _this3.selectedDistr();
              }
            }).catch(function (error) {
              console.log(error);
            });
          } else {
            _this3.selectedDistr();
          }
        });
      } else {
        this.$router.push({ name: 'Obmen' });
      }
    }
  }

});

/***/ }),

/***/ "R5Ta":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__ = __webpack_require__("Mca5");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0806a837_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__ = __webpack_require__("RGwF");
function injectStyle (ssrContext) {
  __webpack_require__("pPMM")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_SideBar_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0806a837_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_SideBar_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "RGwF":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{class:_vm.sidebarClasses,attrs:{"data-background-color":_vm.backgroundColor,"data-active-color":_vm.activeColor}},[_c('div',{staticClass:"logo"},[_c('a',{staticClass:"simple-text logo-mini",attrs:{"href":"https://www.creative-tim.com/product/vue-paper-dashboard-pro"}},[_c('div',{staticClass:"logo-img"},[_c('img',{attrs:{"src":_vm.logo,"alt":""}})])]),_vm._v(" "),_c('a',{staticClass:"simple-text logo-normal",attrs:{"href":"https://www.creative-tim.com/vue-paper-dashboard-pro"}},[_vm._v("\n        "+_vm._s(_vm.title)+"\n    ")])]),_vm._v(" "),_c('div',{ref:"sidebarScrollArea",staticClass:"sidebar-wrapper"},[_vm._t("default"),_vm._v(" "),_c('ul',{class:_vm.navClasses},[_vm._t("links",_vm._l((_vm.sidebarLinks),function(link,index){return _c('sidebar-item',{key:link.name + index,attrs:{"link":link}},_vm._l((link.children),function(subLink,index){return _c('sidebar-item',{key:subLink.name + index,attrs:{"link":subLink}})}),1)}))],2)],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "SSZn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise__);




function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
}

function uuidv4() {
  return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
    return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
  });
}

function checkparam(t) {
  if (t.$route.query.id === undefined) {
    return alert('не указан id');
  }
  if (t.$route.query.rc === undefined) {
    return alert('не указан rcode');
  }
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'start',
  data: function data() {
    return {
      regNewDst: false,
      resp: {},
      inn: '',
      phone: '',
      address: uuidv4(),
      info: '',
      message: '',
      dst: '',
      settings: undefined,
      btnOff: false,
      pch: 0,
      fromApp: 0,
      os: null,
      href: '#'
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    if (this.$route.query.app === '1') {
      this.fromApp = this.$route.query.app;
    }

    this.$db.settings.toArray().then(function (x) {
      if (x.length === 0) {
        _this2.os = getMobileOperatingSystem();
        if (_this2.$route.query.app !== '1') {
          _this2.setHref();
        }
      } else {
        _this2.fromApp = 1;
      }
    });
    if (localStorage.getItem('phone') !== null) {
      this.phone = localStorage.getItem('phone');
      this.pch = 1;
    }
  },

  methods: {
    setHref: function setHref() {
      if (this.fromApp === 0) {
        if (this.os === 'iOS') {
          window.location = 'aki-webzakaz://https://1.aki1.ru/#/?id=' + this.$route.query.id + '&rc=' + this.$route.query.rc + '&client=' + this.$route.query.client + '&magazin=' + this.$route.query.magazin + '&contract=' + this.$route.query.contract + '&firm=' + this.$route.query.firm + '&stock=' + this.$route.query.stock + '&pricelist=' + this.$route.query.pricelist + '&agent=' + this.$route.query.agent + '&assortment=' + this.$route.query.assortment + '&inn=' + this.$route.query.inn + '&phone=' + this.$route.query.phone + '&address=' + this.$route.query.address;
          this.href = 'https://apps.apple.com/ru/app/id1482629784';
        }
        if (this.os === 'Android') {
          window.location = 'aki-webzakaz://https://1.aki1.ru/#/?id=' + this.$route.query.id + '&rc=' + this.$route.query.rc + '&client=' + this.$route.query.client + '&magazin=' + this.$route.query.magazin + '&contract=' + this.$route.query.contract + '&firm=' + this.$route.query.firm + '&stock=' + this.$route.query.stock + '&pricelist=' + this.$route.query.pricelist + '&agent=' + this.$route.query.agent + '&assortment=' + this.$route.query.assortment + '&inn=' + this.$route.query.inn + '&phone=' + this.$route.query.phone + '&address=' + this.$route.query.address;
          this.href = 'https://play.google.com/store/apps/details?id=com.akitorg.provider';
        }
      }
    },
    notification: function notification(type, text, icon) {
      if (icon === '') {
        icon = 'ti-email';
      }
      this.$notify({
        component: {
          template: text
        },
        icon: 'ti-email',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: type });
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(resolve, ms);
      });
    },
    saveSettings: function saveSettings() {
      var _this3 = this;

      var uuid = uuidv4();

      this.$db.settings.put({ curentdst: 0, token: uuid, dbase: this.$route.query.id, regcode: this.$route.query.rc, lastconnection: Date.now(), inn: this.inn, phone: this.phone, address: this.address, info: this.info, сurent_dst: this.$route.query.id }).then(function (r) {
        localStorage.curentDist = _this3.$route.query.id;
        _this3.registration(uuid);
      }).catch(function (e) {
        _this3.message = 'eп' + e;
        console.log(e);
      });
    },
    buttonsave: function buttonsave() {
      var _this4 = this;

      this.btnOff = true;
      var _this = this;

      this.$db.distributors.toArray().then(function (x) {
        if (x.length !== 0) {
          var dbExist = 0;
          for (var i = 0; i < x.length; i++) {
            if (x[i].dbase === _this.$route.query.id) {
              _this4.$db.distributors.where('dbase').equals(_this.$route.query.id).delete();
            }
            if (x[i].dbase === '1389') {
              _this4.$db.distributors.where('dbase').equals('1389').delete();
            }
            if (x[i].dbase === 1389) {
              _this4.$db.distributors.where('dbase').equals(1389).delete();
            }
          }

          if (dbExist !== 1) {
            _this4.saveSettings();
          } else {
            _this.$router.push({ name: 'Obmen' });
          }
        } else {
          _this.saveSettings();
        }
      }).catch(function (e) {
        console.log(e);
        _this4.message = e;
      });
    },
    checksettings: function checksettings() {
      var _this5 = this;

      this.$db.settings.toArray().then(function (x) {
        if (x.length !== 0) {} else {
          checkparam(_this5);
        }
      }).catch(function (e) {
        console.log(e);
        _this5.message = e;
      }).catch(function (e) {
        console.log(e);
        _this5.message = e;
      });
    },
    registration: function registration(uuid) {
      var _this6 = this;

      localStorage.phone = this.phone;
      var x = this.$db.settings.toArray();
      this.settings = x[0];
      var axios = __webpack_require__("mtWM");
      this.resp.inn = this.$route.query.inn;
      this.resp.phone = this.phone;
      this.resp.info = this.info;
      this.resp.client = this.$route.query.client;
      this.resp.magazin = this.$route.query.magazin;
      this.resp.contract = this.$route.query.contract;
      this.resp.firm = this.$route.query.firm;
      this.resp.stock = this.$route.query.stock;
      this.resp.pricelist = this.$route.query.pricelist;
      this.resp.agent = this.$route.query.agent;

      if (this.resp.assortment !== undefined) {
        this.resp.assortment = this.$route.query.assortment;
      }
      this.notification('success', '<span>Начало регистрации</span>');
      var data = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_json_stringify___default()(this.resp);
      axios({
        method: 'post',
        url: 'https://webzakaz.akitorg.ru/i.php',
        headers: { 'X-User-Id': this.$route.query.id, 'X-Authorization': uuid, 'X-Route': 'reg_new' },
        data: data
      }).then(function (res) {
        console.log(res);
        if (res.status === 200) {
          _this6.notification('success', '<span>Зарегистрирован</span>');
          if (res.data.client_extid.length > 0) {
            _this6.$db.settings.update(uuid, { client_extid: res.data.client_extid, firm_name: res.data.firm_name });
            _this6.$db.distributors.put({ name: res.data.firm_name, token: uuid, dbase: _this6.$route.query.id, regcode: _this6.$route.query.rc });
            _this6.$router.push({ name: 'Obmen' });
          }
        }
      }).catch(function (error) {
        localStorage.phone = '';
        _this6.btnOff = false;
        _this6.notification('danger', '<span>Проблемка</span>');
        var er = '<span>' + error + '</span>';
        _this6.notification('danger', er);
        console.log(error);
        if (error.response) {
          if (error.response.data === '400 Invalid phone') {
            console.log('не верный телефон');
            _this6.notification('warning', '<span>не верный телефон</span>');
          }

          if (error.response.data === '411 Array Required') {
            console.log('не верный телефон');
            alert('не верный телефон');
          }

          if (error.response.data === '400 Uuid already registered') {
            console.log('Что то с UUID');
            alert('Что то с UUID');
          }
          if (error.response.data === '401 User Not Found') {
            console.log('401 User Not Found');
            alert('401 User Not Found');
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
      });
    }
  }
});

/***/ }),

/***/ "T1vP":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_GeneralViews_NotFoundPage_vue__ = __webpack_require__("5FAv");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Custom_Start__ = __webpack_require__("b91J");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Custom_Obmen__ = __webpack_require__("iUUw");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Custom_Catalog__ = __webpack_require__("Ohs0");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Custom_Order__ = __webpack_require__("/yTY");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_UIComponents_Custom_OrdersList__ = __webpack_require__("KqLX");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_UIComponents_Custom_First__ = __webpack_require__("wGY7");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_UIComponents_Custom_Settings__ = __webpack_require__("QOVQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_UIComponents_Custom_Deeplink__ = __webpack_require__("skxc");












var routes = [{
  path: '/',
  name: 'Start',
  component: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Custom_Start__["a" /* default */]
}, {
  path: '/dplink',
  name: 'DpLink',
  component: __WEBPACK_IMPORTED_MODULE_8__components_UIComponents_Custom_Deeplink__["a" /* default */]
}, {
  path: '/first',
  name: 'First',
  component: __WEBPACK_IMPORTED_MODULE_6__components_UIComponents_Custom_First__["a" /* default */]
}, {
  path: '/settings',
  name: 'Settings',
  component: __WEBPACK_IMPORTED_MODULE_7__components_UIComponents_Custom_Settings__["a" /* default */]
}, {
  path: '/obmen',
  name: 'Obmen',
  component: __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Custom_Obmen__["a" /* default */]
}, {
  path: '/catalog',
  name: 'Catalog',
  component: __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Custom_Catalog__["a" /* default */]
}, {
  path: '/order',
  name: 'Order',
  component: __WEBPACK_IMPORTED_MODULE_4__components_UIComponents_Custom_Order__["a" /* default */]
}, {
  path: '/orderslist',
  name: 'OrdersList',
  component: __WEBPACK_IMPORTED_MODULE_5__components_UIComponents_Custom_OrdersList__["a" /* default */]
}, { path: '*', component: __WEBPACK_IMPORTED_MODULE_0__components_GeneralViews_NotFoundPage_vue__["a" /* default */] }];

/* harmony default export */ __webpack_exports__["a"] = (routes);

/***/ }),

/***/ "TLj+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"settings"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding":"3px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('center',[_c('div',{staticClass:"col-xs-12"},[_c('h3',[_vm._v("Настройки")])])])],1)])])])]),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding":"3px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('center',[_c('router-link',{attrs:{"to":"/first"}},[_c('button',{staticClass:"btn btn-default btn-lg",staticStyle:{"width":"230px"}},[_vm._v("Выбор поставщика\n                                        ")])])],1)],1)]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"col-xs-12"},[_c('center',[_c('router-link',{attrs:{"to":"/obmen"}},[_c('button',{staticClass:"btn btn-success btn-lg",staticStyle:{"width":"230px"}},[_vm._v("Обновить каталог\n                                        ")])])],1)],1)])])])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"position":"fixed","z-index":"9990","background":"rgba(4,7,6,0.27)","height":"60px","bottom":"0px","width":"100%"},attrs:{"id":"menu"}},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"4%","padding":"0px","border-top":"1px ridge rgba(4,7,6,0.16)"}},[_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/catalog"}},[_c('center',[_c('i',{staticClass:"ti-agenda",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Каталог")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/order"}},[_c('center',[_c('i',{staticClass:"ti-shopping-cart",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Заказ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/orderslist"}},[_c('center',[_c('i',{staticClass:"ti-timer",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("История")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"#ececec","padding":"10px"}},[_c('router-link',{attrs:{"to":"/settings"}},[_c('center',[_c('i',{staticClass:"ti-more-alt",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Ещё")])])],1)],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Tq9h":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'GoodsList',
  props: {
    goodsarr2: undefined,
    order: undefined
  }
});

/***/ }),

/***/ "UTB8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c(_vm.tag,{directives:[{name:"click-outside",rawName:"v-click-outside",value:(_vm.closeDropDown),expression:"closeDropDown"}],tag:"div",class:[_vm.getSlideClass, {open:_vm.isOpen}],on:{"click":_vm.toggleDropDown}},[_vm._t("title",[_c('a',{staticClass:"dropdown-toggle btn-rotate",attrs:{"data-toggle":"dropdown","href":"javascript:void(0)"}},[_c('i',{class:_vm.icon}),_vm._v(" "),_c('p',{staticClass:"notification"},[_vm._v(_vm._s(_vm.title)+"\n        "),_c('b',{staticClass:"caret"})])])]),_vm._v(" "),_c('ul',{staticClass:"dropdown-menu"},[_vm._t("default")],2)],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "VHDh":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoaderCustom_vue__ = __webpack_require__("cWmx");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_082fdc8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoaderCustom_vue__ = __webpack_require__("+m3G");
function injectStyle (ssrContext) {
  __webpack_require__("gpO4")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-082fdc8c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_LoaderCustom_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_082fdc8c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_LoaderCustom_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "VwNU":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrderInfo',
  props: ['order_sum', 'order_uuid'],
  data: function data() {
    return {
      order: [],
      resp: {},
      message: ''
    };
  },

  methods: {
    send: function send(orderid) {
      this.message = 'Нажал';
      this.load_order(orderid);
    },
    get_json: function get_json() {
      var _this = this;

      this.$db.settings.toArray().then(function (x) {
        return _this.resp = x;
      }).then(this.resp.push({ ddate: this.order.dt })).then(console.log(this.resp));
    },
    load_order: function load_order(orderid) {
      var _this2 = this;

      this.message = 'пришел в load_order';
      var axios = __webpack_require__("mtWM");
      this.$db.orders.where({ 'id': orderid }).toArray().then(function (order) {
        return order;
      }).then(function (order) {
        var date = '2019-09-27 13:13:09.267';

        _this2.resp.goods = order[0].goods;

        _this2.resp.number = order[0].dt;

        _this2.resp.ddate = date;
        _this2.resp.ddate2 = date;
        _this2.resp.deliverydate = date;
        _this2.resp.info = 'comment';

        _this2.$db.settings.toArray().then(function (settings) {
          for (var key in settings[0]) {
            _this2.resp[key] = settings[0][key];
          }
          _this2.message = 'ща пошлю';
          axios({
            method: 'post',
            url: 'https://lic2.akitorg.ru/ms_au/j.php',
            headers: { 'X-Akitorg-Agent': '18', 'X-Authorization': 'R30TSsZ53SWPVe3K', 'X-Akitorg-User-Id': '227' },
            data: _this2.resp
          }).then(console.log('************************')).catch(function (error) {
            console.log(error);
            _this2.message = error;
          }).finally(function () {
            console.log('фсё');
            _this2.message = 'фсё';
          });
        });
      });
    }
  }
});

/***/ }),

/***/ "VziK":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-5"},[_vm._t("header")],2),_vm._v(" "),_c('div',{staticClass:"col-xs-7"},[_vm._t("content")],2)])]),_vm._v(" "),_c('div',{staticClass:"card-footer"},[_c('hr'),_vm._v(" "),_vm._t("footer")],2)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "Wdwa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "Whb+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_vm._l((_vm.orders),function(order){return _c('div',{staticClass:"col-xs-12"},[_c('div',[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header",on:{"click":function($event){return _vm.show_order(order.id)}}},[_c('div',{staticClass:"col-xs-12"},[_c('h4',{staticClass:"card-title"},[_vm._v("Заказ на сумму "+_vm._s(order.sum + ''))]),_vm._v(" "),_c('p',{staticClass:"category"},[_vm._v(_vm._s(order.dt))])])]),_vm._v(" "),_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"z-index":"99"},on:{"click":function($event){return _vm.show_order(order.id)}}},[_c('p',{staticClass:"text-success"},[_vm._v(_vm._s(order.status))]),_vm._v(" "),(order.info.length>0)?_c('p',{staticClass:"text"},[_vm._v(_vm._s(order.info))]):_vm._e(),_vm._v(" "),(_vm.opend_order.find(function (i){ return i===order.id; }))?_c('div',[_c('center',[_c('i',{staticClass:"ti-angle-up"})])],1):_c('div',[_c('center',[_c('i',{staticClass:"ti-angle-down"})])],1)]),_vm._v(" "),_c('hr'),_vm._v(" "),_c('div',{staticClass:"row"},[(_vm.opend_order.find(function (i){ return i===order.id; }))?_c('show-order',{attrs:{"order_uuid":order.id}}):_vm._e()],1)])])])])}),_vm._v(" "),_vm._m(0),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"position":"fixed","z-index":"9990","background":"rgba(4,7,6,0.27)","height":"60px","bottom":"0px","width":"100%"},attrs:{"id":"menu"}},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"4%","padding":"0px","border-top":"1px ridge rgba(4,7,6,0.16)"}},[_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/catalog"}},[_c('center',[_c('i',{staticClass:"ti-agenda",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Каталог")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/order"}},[_c('center',[_c('i',{staticClass:"ti-shopping-cart",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Заказ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"padding":"10px","background":"#ececec"}},[_c('router-link',{attrs:{"to":"/orderslist"}},[_c('center',[_c('i',{staticClass:"ti-timer",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("История")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/settings"}},[_c('center',[_c('i',{staticClass:"ti-more-alt",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Ещё")])])],1)],1)])])],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-12",staticStyle:{"margin-bottom":"80px","height":"40px"}},[_c('hr')])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "XXRA":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__ = __webpack_require__("mvHQ");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2__ = __webpack_require__("PBfN");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_sweetalert2__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__OrderInfo__ = __webpack_require__("PbAS");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifyjs_themes_default_css__ = __webpack_require__("p4sG");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_vue_notifyjs_themes_default_css___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_vue_notifyjs_themes_default_css__);










/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Order',
  components: { OrderInfo: __WEBPACK_IMPORTED_MODULE_3__OrderInfo__["a" /* default */] },
  data: function data() {
    return {
      info: '',
      settings: undefined,
      shownot: false,
      resp: {},
      showbuttons: true,
      itog: 0,
      link: 'https://images.akitorg.ru/images/',
      order: [],
      btnOff: false,
      distr: undefined,
      token: undefined,
      regcode: undefined
    };
  },
  mounted: function mounted() {
    var _this = this;

    if (localStorage.getItem('curentDist')) {
      this.distr = localStorage.getItem('curentDist');
    }
    this.$db.distributors.where('dbase').equals(this.distr).toArray().then(function (x) {
      _this.token = x[0].token;
      _this.regcode = x[0].regcode;
    });

    this.load_save_order();
    this.checksettings();
    this.getphotolink();
  },

  methods: {
    getphotolink: function getphotolink() {
      this.link = this.link + this.regcode + '/goods_photos/';
    },
    load_save_order: function load_save_order() {
      var _this2 = this;

      var p = this.$db.order.toArray();
      p.then(function (x) {
        _this2.order = x;
        _this2.order_sum();
      });
    },
    order_sum: function order_sum() {
      var itog = 0;
      this.order.forEach(function (item) {
        itog = itog + item.price * item.quantity * item.multiplier;
      });
      itog = Math.floor(itog * 100) / 100;
      this.itog = itog;

      return itog;
    },

    photo_src: function photo_src(good) {
      if (good.isgroup) {
        return '<i class="ti-folder" style="font-size:2rem;"></i>';
      } else if (good.photo != '') {
        return '<img src="' + this.link + good.photo + '" alt="..." style="width: 5rem;"/>';
      } else {
        return '<i class="ti-image" style="font-size:3rem;"></i>';
      }
    },
    delete_item: function delete_item(i) {
      this.order.splice(i, 1);
    },
    clear_2: function clear_2(i) {
      var _this3 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        title: 'Точно удалить?',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      }).then(function (result) {
        if (result) {
          _this3.$db.order.where({ 'good': i }).delete();
          _this3.load_save_order();
        }
      });
    },
    showSwal: function showSwal(type, good) {
      var _this4 = this;

      if (good.isgroup) {
        return;
      }
      var quantity = 0;
      var photo = '';
      quantity = good.quantity;
      if (good.photo !== '' && good.photo.length > 4) {
        photo = '<img src="' + this.link + good.photo + '" alt="..." style="width: 40%; height: 40%; max-height: 40%;">';
      } else {
        photo = '';
      }
      this.showbuttons = false;
      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        title: good.name,
        html: '<div class="form-group">' + photo + '</div>',
        input: 'number',
        inputValue: quantity,
        inputPlaceholder: 'Введите количество',

        showCloseButton: true,

        reverseButtons: true
      }).then(function (result) {
        if (result > 0) {
          _this4.set_q(good, result);
        } else if (result === '0' | result === '') {
          _this4.dellgood(good.good);
        }
      }).catch(function (x) {}).finally(function (x) {
        _this4.showbuttons = true;
      });
    },
    set_q: function set_q(good, q) {
      var dsum = Math.floor(q * good.price * 100) / 100;
      var b = this.order.findIndex(function (x) {
        return x.good === good.good;
      });
      if (b >= 0) {
        this.$set(this.order, b, {
          good: good.good,
          quantity: q,
          price: good.price,
          name: good.name,
          photo: good.photo,
          unit: 0,
          dsum: dsum,
          multiplier: 1,
          discount: 0,
          project: 0,
          info: ''
        });
      } else {
        this.order.push({
          good: good.good,
          quantity: q,
          price: good.price,
          name: good.name,
          photo: good.photo,
          unit: 0,
          dsum: dsum,
          multiplier: 1,
          discount: 0,
          project: 0,
          info: ''
        });
      }
      this.$db.order.bulkPut(this.order);
      this.order_sum();
    },
    dellgood: function dellgood(goodid) {
      var a = this.order.findIndex(function (x) {
        return x.good === goodid;
      });
      this.order.splice(a, 1);
      this.$db.order.where('good').equals(goodid).delete();
      this.order_sum();
    },
    clear_order: function clear_order() {
      var _this5 = this;

      __WEBPACK_IMPORTED_MODULE_2_sweetalert2___default()({
        title: 'Точно удалить весь заказ?',
        showCancelButton: true,
        confirmButtonClass: 'btn btn-success btn-fill',
        cancelButtonClass: 'btn btn-danger btn-fill',
        buttonsStyling: false
      }).then(function (result) {
        if (result) {
          _this5.order = [];
          _this5.$db.order.clear();
          _this5.order_sum();
          _this5.order_tap = false;
        }
      }).catch(function (error) {
        console.log(error);
      });
    },
    notification: function notification(type, text, icon) {
      if (icon === '') {
        icon = 'ti-email';
      }
      this.$notify({
        component: {
          template: text
        },
        icon: 'ti-email',
        horizontalAlign: 'right',
        verticalAlign: 'top',
        type: type });
    },
    save_order: function save_order() {
      var _this6 = this;

      this.btnOff = true;
      this.notification('warning', '<span>....</span>');
      this.notification('warning', '<span>Отправляю заказ</span>');
      var time = new Date().toISOString();
      var dt = time.slice(0, 10) + ' ' + time.slice(11, 19);
      var sum = this.order_sum();
      this.$db.orders.put({ goods: this.order, sum: sum, dt: dt, status: 'Сохранен но не отправлен', info: this.info }).then(function (orderid) {
        var goodstosend = JSON.parse(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(_this6.order));
        for (var key in goodstosend) {
          delete goodstosend[key].name;
          delete goodstosend[key].photo;
          delete goodstosend[key].discount;

          delete goodstosend[key].project;

          delete goodstosend[key].info;
        }
        _this6.resp.goods = goodstosend;
        _this6.resp.number = orderid;
        _this6.resp.ddate = dt;
        _this6.resp.info = _this6.info;

        _this6.order_tap = false;
        _this6.send_order();
      }).catch(function (error) {
        _this6.shownot = false;
        console.log(error);
      });
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        return setTimeout(resolve, ms);
      });
    },
    checksettings: function checksettings() {
      var _this7 = this;

      this.$db.settings.toArray().then(function (x) {
        if (x.length !== 0) {
          _this7.settings = x[0];
        } else {
          console.log('А нету настроек');
        }
      }).catch(function (e) {
        console.log(e);
      });
    },
    send_order: function send_order() {
      var _this8 = this;

      this.message = 'пришел в load_order';
      var axios = __webpack_require__("mtWM");
      var data = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_core_js_json_stringify___default()(this.resp);
      axios({
        method: 'post',
        url: 'https://webzakaz.akitorg.ru/i.php',
        headers: { 'X-User-Id': this.distr, 'X-Authorization': this.token, 'X-Route': 'add_order' },
        data: data
      }).then(function (res) {
        if (res.status === 200) {
          if (res.data.id > 0) {
            _this8.$db.orders.update(_this8.resp.number, { status: 'Отправлен поставщику' });
            _this8.notification('success', '<span>Заказ отправлен</span>');
            _this8.$db.order.clear();
            _this8.order = [];
            _this8.sleep(2000).then(function () {
              _this8.$router.push({ name: 'OrdersList' });
            });
          }
        }
      }).catch(function (error) {
        _this8.notification('danger', '<span>' + error + '</span>');
        _this8.shownot = false;
        _this8.sleep(1000).then(function () {
          _this8.shownot = false;
        });
      });
    }
  }
});

/***/ }),

/***/ "XjMg":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "YZVa":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "ZQf1":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__ = __webpack_require__("sQGm");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f6b188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__ = __webpack_require__("UTB8");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Dropdown_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_e9f6b188_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Dropdown_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "b91J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__ = __webpack_require__("SSZn");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74fa155f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__ = __webpack_require__("wt7y");
function injectStyle (ssrContext) {
  __webpack_require__("uP4A")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-74fa155f"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Start_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_74fa155f_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Start_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "cWmx":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Loader'
});

/***/ }),

/***/ "ceY1":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "dctX":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "eAxr":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "eU1q":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'fg-input',
  inheritAttrs: false,
  props: {
    value: {
      type: String,
      default: ''
    },
    label: String
  }
});

/***/ }),

/***/ "euVw":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "gKTg":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"contact-us full-screen"},[_c('nav',{staticClass:"navbar navbar-ct-default",attrs:{"role":"navigation-demo"}},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"navbar-header"},[_vm._m(0),_vm._v(" "),_c('router-link',{staticClass:"navbar-brand",attrs:{"to":{path:'/'}}},[_vm._v("Site title")])],1),_vm._v(" "),_c('div',{staticClass:"collapse navbar-collapse",attrs:{"id":"navigation-example-2"}},[_c('ul',{staticClass:"nav navbar-nav navbar-right"},[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1)])])])]),_vm._v(" "),_vm._m(1),_vm._v(" "),_c('footer',{staticClass:"footer-demo"},[_c('div',{staticClass:"container"},[_c('nav',{staticClass:"pull-left"},[_c('ul',[_c('li',[_c('router-link',{attrs:{"to":{path:'/'}}},[_vm._v("Home")])],1),_vm._v(" "),_c('li',[_c('router-link',{attrs:{"to":{path:'/register'}}},[_vm._v("Register")])],1)])]),_vm._v(" "),_vm._m(2)])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"navbar-toggle",attrs:{"type":"button","data-toggle":"collapse","data-target":"#navigation-example-2"}},[_c('span',{staticClass:"sr-only"},[_vm._v("Toggle navigation")]),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"}),_vm._v(" "),_c('span',{staticClass:"icon-bar"})])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper wrapper-full-page section content"},[_c('div',{},[_c('div',{staticClass:"container"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-md-8 col-md-offset-2 text-center"},[_c('h2',{staticClass:"title text-danger"},[_vm._v("404 Not Found")]),_vm._v(" "),_c('h2',{staticClass:"title"},[_vm._v("Oops! It seems that this page does not exist.")])])])])])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"copyright pull-right"},[_vm._v("\n        © 2017, made with\n        "),_c('i',{staticClass:"fa fa-heart heart"}),_vm._v(" by Paper admin\n      ")])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gMe+":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"deeplink"}},[(_vm.os!=null)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"40%","padding":"30px"}},[_c('center',[_c('h3',[_vm._v("Загрузите приложение для "+_vm._s(_vm.os)+" по кнопке")])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"padding":"3px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"20px"}},[_c('center',[_c('a',{staticClass:"btn btn-lg btn-info",attrs:{"href":_vm.href}},[_vm._v("Установить приложение")])])],1)])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "gpO4":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "hdUz":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.shownot)?_c('div',{attrs:{"id":"sendcomplite"}}):_c('div',{attrs:{"id":"order"}},[(_vm.showbuttons)?_c('div',{staticClass:"row",staticStyle:{"position":"fixed","z-index":"9999","background":"white","min-height":"60px","top":"0px","border":"1px solid #e8e7e3","width":"100%"},attrs:{"id":"static-top"}},[_c('div',{staticClass:"col-xs-2",staticStyle:{"padding-left":"20px","padding-top":"25px"}},[_c('router-link',{staticStyle:{"color":"black"},attrs:{"to":"/catalog"}},[_c('span',{staticStyle:{"font-size":"20px"},on:{"click":function($event){}}},[_c('i',{staticClass:"ti-arrow-left"})])])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('center',[_c('h3',[_vm._v("Заказ")])])],1),_vm._v(" "),_c('div',{staticClass:"col-xs-2",staticStyle:{"padding-left":"6px","padding-top":"25px"}},[_c('span',{staticStyle:{"font-size":"20px"},on:{"click":function($event){return _vm.clear_order()}}},[_c('i',{staticClass:"ti-trash"})])])]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-sm-12",staticStyle:{"padding":"3px"}},[_c('div',{staticClass:"card",staticStyle:{"margin-top":"40px"}},[_c('div',{staticClass:"card-content"},_vm._l((_vm.order),function(item,index){return _c('div',{key:item.good,staticClass:"row",on:{"click":function($event){return _vm.showSwal('input-field', item)}}},[_c('hr',{staticStyle:{"margin":"10px"}}),_vm._v(" "),_c('div',{staticClass:"col-xs-9"},[_vm._v("\n                                    "+_vm._s(item.quantity + ' x ' + item.name)+"\n                                ")]),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"text-align":"right","padding":"0"}},[_vm._v("\n                                    "+_vm._s(Math.floor(item.price * item.quantity * item.multiplier * 100) / 100)+" p.\n                                ")])])}),0)]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12"},[_c('div',{staticClass:"form-group"},[_c('label',{attrs:{"for":"Textarea1"}},[_vm._v("Коментарий")]),_vm._v(" "),_c('textarea',{directives:[{name:"model",rawName:"v-model",value:(_vm.info),expression:"info"}],staticClass:"form-control",attrs:{"id":"Textarea1","rows":"1"},domProps:{"value":(_vm.info)},on:{"input":function($event){if($event.target.composing){ return; }_vm.info=$event.target.value}}},[_vm._v(_vm._s(_vm.info))])])])])])]),_vm._v(" "),_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-8"},[_c('p',{staticStyle:{"font-size":"20px","text-align":"right"}},[_vm._v(_vm._s(_vm.itog))])])]),_vm._v(" "),(!_vm.itog)?_c('div',[_c('hr'),_vm._v(" "),_c('p',[_vm._v("Вы еще не создали заказ, перейдите в каталог для выбора товаров.")])]):_vm._e()])]),_vm._v(" "),_vm._m(1)])]),_vm._v(" "),(_vm.showbuttons&&_vm.itog>0)?_c('div',{staticClass:"row",staticStyle:{"position":"fixed","z-index":"9990","background":"white","min-height":"60px","bottom":"60px","width":"100%"},attrs:{"id":"static-order"}},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"4%","padding-bottom":"10px"}},[_c('router-link',{attrs:{"to":"/order"}},[_c('button',{staticClass:"btn btn-success btn-fill btn-wd",staticStyle:{"height":"60px","width":"100%"},attrs:{"disabled":_vm.btnOff},on:{"click":function($event){return _vm.save_order()}}},[_c('span',{staticClass:"center"},[_vm._v("Отправить поставщику")])])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"position":"fixed","z-index":"9990","background":"rgba(4,7,6,0.27)","height":"60px","bottom":"0px","width":"100%"},attrs:{"id":"menu"}},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-left":"4%","padding":"0px","border-top":"1px ridge rgba(4,7,6,0.16)"}},[_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/catalog"}},[_c('center',[_c('i',{staticClass:"ti-agenda",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Каталог")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"#ececec","padding":"10px"}},[_c('router-link',{attrs:{"to":"/order"}},[_c('center',[_c('i',{staticClass:"ti-shopping-cart",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Заказ")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/orderslist"}},[_c('center',[_c('i',{staticClass:"ti-timer",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("История")])])],1)],1),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"background":"white","padding":"10px"}},[_c('router-link',{attrs:{"to":"/settings"}},[_c('center',[_c('i',{staticClass:"ti-more-alt",staticStyle:{"font-size":"20px","padding-top":"6px"}}),_vm._v(" "),_c('br'),_vm._v(" "),_c('span',{staticStyle:{"font-size":"1em"}},[_vm._v("Ещё")])])],1)],1)])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-4"},[_c('span',{staticStyle:{"font-size":"20px"}},[_vm._v("Итого:")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"card",staticStyle:{"margin-bottom":"160px"}},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row",staticStyle:{"margin":"6px"}})])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "hxRq":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "iUUw":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Obmen_vue__ = __webpack_require__("oj1P");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7acadd00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Obmen_vue__ = __webpack_require__("NfYk");
function injectStyle (ssrContext) {
  __webpack_require__("YZVa")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-7acadd00"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Obmen_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_7acadd00_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Obmen_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "iXuc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__ = __webpack_require__("Ond/");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__ = __webpack_require__("ZQf1");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__ = __webpack_require__("kVx9");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__ = __webpack_require__("wH4b");






var GlobalComponents = {
  install: function install(Vue) {
    Vue.component(__WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_0__components_UIComponents_Inputs_formGroupInput_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_1__components_UIComponents_Dropdown_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_2__components_UIComponents_Inputs_Checkbox_vue__["a" /* default */]);
    Vue.component(__WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */].name, __WEBPACK_IMPORTED_MODULE_3__components_UIComponents_Inputs_Radio_vue__["a" /* default */]);
  }
};

/* harmony default export */ __webpack_exports__["a"] = (GlobalComponents);

/***/ }),

/***/ "ilcf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"order_info"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-lg-8 col-sm-12"},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row",staticStyle:{"padding":"15px"}},[_c('textarea',{staticClass:"form-control",attrs:{"placeholder":"Коментарий к заказу","rows":"3"}},[_vm._v(_vm._s(_vm.message))])]),_vm._v(" "),_c('div',{staticClass:"row"},[_vm._m(0),_vm._v(" "),_c('div',{staticClass:"col-xs-7"},[_c('button',{staticClass:"btn btn-success btn-fill btn-wd",on:{"click":function($event){return _vm.send(_vm.order_uuid)}}},[_vm._v("Отправить")])])])])])])])])}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-5"},[_c('button',{staticClass:"btn btn-wd"},[_vm._v("Отмена")])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "im4J":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__ = __webpack_require__("MU8w");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_es6_promise_auto___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_es6_promise_auto__);


/* unused harmony default export */ var _unused_webpack_default_export = ((function initPollyFills() {
  if (!String.prototype.startsWith) {
    String.prototype.startsWith = function (searchString, position) {
      position = position || 0;
      return this.indexOf(searchString, position) === position;
    };
  }
  if (!Array.prototype.find) {
    Object.defineProperty(Array.prototype, 'find', {
      value: function value(predicate) {
        if (this == null) {
          throw new TypeError('"this" is null or not defined');
        }

        var o = Object(this);

        var len = o.length >>> 0;

        if (typeof predicate !== 'function') {
          throw new TypeError('predicate must be a function');
        }

        var thisArg = arguments[1];

        var k = 0;

        while (k < len) {
          var kValue = o[k];
          if (predicate.call(thisArg, kValue, k, o)) {
            return kValue;
          }

          k++;
        }

        return undefined;
      }
    });
  }
})());

/***/ }),

/***/ "kVx9":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__ = __webpack_require__("uEKC");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__ = __webpack_require__("+2Xc");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Checkbox_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_071d300e_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Checkbox_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "l1vO":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "mMtV":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ShowOrder__ = __webpack_require__("7mvM");



/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'OrdersList',
  components: { ShowOrder: __WEBPACK_IMPORTED_MODULE_0__ShowOrder__["a" /* default */] },
  data: function data() {
    return {
      orders: [],
      message: '',
      opend_order: []
    };
  },
  mounted: function mounted() {
    this.get_orders();
  },

  methods: {
    get_orders: function get_orders() {
      var _this = this;

      this.$db.orders.where('sum').above(0).reverse().sortBy('dt').then(function (x) {
        return _this.orders = x;
      });
    },
    date_format: function date_format(dt) {
      var d = new Date(dt);
      return d.toLocaleString('ru-RU');
    },
    show_order: function show_order(orderid) {
      var ind = this.opend_order.indexOf(orderid);
      if (ind >= 0) {
        this.opend_order.splice(ind, 1);
      } else {
        this.opend_order.push(orderid);
      }
    },
    save_order: function save_order(orderid) {}
  }
});

/***/ }),

/***/ "oj1P":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__ = __webpack_require__("//Fk");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Custom_LoaderCustom__ = __webpack_require__("VHDh");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Cards_StatsCard__ = __webpack_require__("vNb6");






/* harmony default export */ __webpack_exports__["a"] = ({
  components: {
    Loader: __WEBPACK_IMPORTED_MODULE_1_src_components_UIComponents_Custom_LoaderCustom__["a" /* default */],
    StatsCard: __WEBPACK_IMPORTED_MODULE_2__Cards_StatsCard__["a" /* default */]
  },
  name: 'Obmen',
  data: function data() {
    return {
      l: '',
      loader: false,
      message: '',
      timerId: 0,
      settings: undefined,
      disable: false,
      distr: 0,
      token: null
    };
  },
  mounted: function mounted() {
    var _this2 = this;

    if (localStorage.getItem('curentDist')) {
      this.distr = localStorage.getItem('curentDist');
      this.setToken();
    } else {
      this.$db.settings.toArray().then(function (x) {
        if (x.length > 0) {
          _this2.distr = x[0].dbase;
          _this2.token = x[0].token;
          localStorage.curentDist = x[0].dbase;
          _this2.setToken();
        }
      });
    }

    this.checksettings();
  },

  methods: {
    setToken: function setToken() {
      var _this3 = this;

      this.$db.settings.where({ 'dbase': this.distr }).toArray().then(function (x) {
        _this3.token = x[0].token;
      }).catch(function (e) {
        console.log(e);
      });
    },
    sleep: function sleep(ms) {
      return new __WEBPACK_IMPORTED_MODULE_0_babel_runtime_core_js_promise___default.a(function (resolve) {
        setTimeout(resolve, ms);
      });
    },
    ldt: function ldt(i) {
      if (this.l.length > 200) {
        this.l = '';
      }
      this.l = this.l + '<span><i class="ti-angle-right"></i></span>';
    },
    checksettings: function checksettings() {
      var _this4 = this;

      this.$db.settings.toArray().then(function (x) {
        if (x.length !== 0) {
          _this4.settings = x[0];
        } else {
          _this4.$router.push({ name: 'Start' });
        }
      }).catch(function (e) {
        console.log(e);
      }).finally(function () {
        if (_this4.settings) {
          _this4.get_goods();
        }
      });
    },
    get_goods: function get_goods() {
      var _this5 = this;

      var _this = this;
      this.disable = true;
      this.timerId = setInterval(function () {
        return _this5.ldt('ti-angle-right');
      }, 500);
      this.message = 'Идет обновление';

      var axios = __webpack_require__("mtWM");
      axios({
        method: 'post',
        url: 'https://webzakaz.akitorg.ru/i.php',
        headers: { 'X-User-Id': this.distr, 'X-Authorization': this.token, 'X-Route': 'get_prices' },
        data: { phone: '' }
      }).then(function (res) {
        _this5.message = 'запрос выполнен';

        _this5.$db.settings.update(_this5.settings.token, { lastconnection: Date.now() });

        if (res.status === 200) {
          var goods = res.data;
          goods.forEach(function (item, i, goods) {
            var a = {};
            a = item;
            a.distr = _this.distr;
            goods[i] = a;
          });

          _this5.$db.goods.clear();
          _this5.$db.goods.bulkPut(goods).then(function () {
            _this5.loader = false;
            _this5.message = 'Каталог успешно обновлен';
            clearInterval(_this5.timerId);
            _this5.l = '<span style="font-size: 20px;"><i class="ti-face-smile"></i></span>';
            _this5.disable = false;

            _this5.sleep(600).then(function () {
              _this5.$router.push({ path: 'catalog', query: { refresh: '1' } });
            });
          });
        } else {
          _this5.message = res.status;
        }
      }).catch(function (error) {
        _this5.disable = false;
        console.log(error);

        _this5.message = error.response.data;
        if (error.response) {
          if (error.response.data === '400 Invalid phone') {
            console.log('не верный телефон');
            alert('не верный телефон');
          }
          if (error.response.data === '400 Invalid INN') {
            console.log('не верный ИНН');
            alert('не верный ИНН');
          }
          if (error.response.data === '411 Array Required') {
            console.log('не верный телефон');
            alert('не верный телефон');
          }
          if (error.response.data === '400 INN not found') {
            console.log('не верный INN');
            alert('не верный INN');
          }
          if (error.response.data === '400 Uuid already registered') {
            console.log('Что то с UUID');
            alert('Что то с UUID');
          }
        } else if (error.request) {
          console.log(error.request);
        } else {
          console.log('Error', error.message);
        }
      });
    }
  }
});

/***/ }),

/***/ "p4sG":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "pPMM":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "qVEa":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


function getMobileOperatingSystem() {
  var userAgent = navigator.userAgent || navigator.vendor || window.opera;

  if (/android/i.test(userAgent)) {
    return 'Android';
  }

  if (/iPad|iPhone|iPod/.test(userAgent) && !window.MSStream) {
    return 'iOS';
  }

  return 'unknown';
}

/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'Deeplin',
  data: function data() {
    return {
      os: null,
      href: '#'
    };
  },
  mounted: function mounted() {
    this.os = getMobileOperatingSystem();
    this.setHref();
  },

  methods: {
    setHref: function setHref() {
      if (this.os === 'iOS') {
        window.location = 'aki-webzakaz://https://1.aki1.ru/#/?id=1664&rc=wSha4F2b2J5N&client=172&magazin=0&contract=685&firm=1&stock=1&pricelist=1&agent=1&assortment=1&inn=&phone=&address=';
        this.href = 'https://apps.apple.com/ru/app/id1482629784';
      }
    }
  }
});

/***/ }),

/***/ "qXdX":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',_vm._l((_vm.goodsarr2),function(good){return _c('div',{key:good.id,staticClass:"row",on:{"click":function($event){return _vm.levelup(good)}}},[_c('hr'),_vm._v(" "),_c('div',{staticClass:"col-xs-3",staticStyle:{"padding-left":"15px"},on:{"click":function($event){return _vm.showSwal('input-field', good)}}}),_vm._v(" "),_c('div',{staticClass:"col-xs-9",staticStyle:{"padding-left":"5px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding-right":"3px","padding-left":"3px"}},[_c('div',{staticClass:"td-name pull-left"},[_vm._v(_vm._s(good.name))])])]),_vm._v(" "),_c('div',{staticClass:"row",staticStyle:{"width":"100%"}},[_c('div',{staticClass:"col-xs-6",staticStyle:{"padding-left":"0px","padding-right":"0"}},[_c('div',{staticClass:"col-xs-5",staticStyle:{"padding-left":"0px","padding-right":"3px"}},[_c('div',{staticClass:"td-sum"},[(good.price)?[_vm._v("\n                                "+_vm._s(good.price +  '')+"\n                            ")]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-7",staticStyle:{"padding-left":"10px","padding-right":"5px"}},[_c('div',{staticClass:"td-order"},[(_vm.order.find(function (x) { return x.good === good.id; }))?[_c('p',[_c('span',{},[_vm._v("х "+_vm._s(_vm.order.find(function (x) { return x.good === good.id; }).quantity)+" ")]),_vm._v(" "+_vm._s(good.unit))])]:_vm._e()],2)]),_vm._v(" "),_c('div',{staticClass:"col-xs-10",staticStyle:{"padding":"0px"}},[_c('div',{staticClass:"td-order"},[(_vm.order.find(function (x) { return x.good === good.id; }))?void 0:_vm._e()],2)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-6",staticStyle:{"padding-left":"0px","padding-right":"0"}},[_c('div',{staticClass:"col-xs-6",staticStyle:{"padding-left":"0px","padding-right":"0"}},[(good.isgroup === 0)?[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.remove_good(good)}}},[_c('i',{staticClass:"ti-minus"})])]:_vm._e()],2),_vm._v(" "),_c('div',{staticClass:"col-xs-6",staticStyle:{"padding-left":"0px","padding-right":"15px"}},[(good.isgroup === 0)?[_c('button',{staticClass:"btn btn-default",on:{"click":function($event){return _vm.add_good(good)}}},[_c('i',{staticClass:"ti-plus"})])]:_vm._e()],2)])])])])}),0)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "sQGm":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'drop-down',
  props: {
    title: String,
    icon: String,
    slide: {
      type: String,
      default: 'down'
    },
    tag: {
      type: String,
      default: 'div'
    }
  },
  computed: {
    getSlideClass: function getSlideClass() {
      return this.slide === 'down' ? 'dropdown' : 'dropup';
    }
  },
  data: function data() {
    return {
      isOpen: false
    };
  },

  methods: {
    toggleDropDown: function toggleDropDown() {
      this.isOpen = !this.isOpen;
    },
    closeDropDown: function closeDropDown() {
      this.isOpen = false;
    }
  }
});

/***/ }),

/***/ "skxc":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deeplink_vue__ = __webpack_require__("qVEa");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9459bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Deeplink_vue__ = __webpack_require__("gMe+");
function injectStyle (ssrContext) {
  __webpack_require__("ceY1")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-0e9459bc"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Deeplink_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_0e9459bc_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Deeplink_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "tRFf":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"container",attrs:{"id":"first"}},[_c('div',{staticClass:"row",staticStyle:{"margin-top":"15px"}},[(_vm.curentDist!=null)?_c('div',{staticClass:"col-xs-2",staticStyle:{"padding-left":"20px","padding-top":"10px"}},[_c('router-link',{staticStyle:{"color":"black"},attrs:{"to":"/settings"}},[_c('span',{staticStyle:{"font-size":"20px"},on:{"click":function($event){}}},[_c('i',{staticClass:"ti-arrow-left"})])])],1):_vm._e(),_vm._v(" "),_vm._m(0)]),_vm._v(" "),_vm._m(1),_vm._v(" "),_vm._l((_vm.distr),function(d){return _c('div',{key:d.dbase,staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding":"3px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-10",on:{"click":function($event){return _vm.dellOrder(d.dbase)}}},[_c('h4',{staticClass:"title"},[_vm._v(_vm._s(d.name))])]),_vm._v(" "),_c('div',{staticClass:"col-xs-2",on:{"click":function($event){return _vm.dellDistr(d.dbase)}}},[_c('i',{staticClass:"ti-trash",staticStyle:{"font-size":"30px"}})])])])])])])})],2)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"col-xs-10",staticStyle:{"padding-top":"10px"}},[_c('p',{staticClass:"title"},[_vm._v("Выберите поставщика")])])},function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"padding":"3px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-content"},[_c('div',{staticClass:"row"},[_c('a',{attrs:{"href":"https://1.aki1.ru/#/catalog?add=1"}},[_c('div',{staticClass:"col-xs-2",staticStyle:{"margin-top":"25px"}},[_c('i',{staticClass:"ti-plus",staticStyle:{"font-size":"30px"}})]),_vm._v(" "),_c('div',{staticClass:"col-xs-10"},[_c('h4',[_vm._v("Добавить")])])])])])])])])}]
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "uEKC":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";


/* harmony default export */ __webpack_exports__["a"] = ({
  name: 'p-checkbox',
  model: {
    prop: 'checked'
  },
  props: {
    checked: [Array, Boolean],
    disabled: [Boolean, String],
    inline: Boolean
  },
  data: function data() {
    return {
      cbId: ''
    };
  },

  computed: {
    model: {
      get: function get() {
        return this.checked;
      },
      set: function set(check) {
        this.$emit('input', check);
      }
    },
    inlineClass: function inlineClass() {
      if (this.inline) {
        return 'checkbox-inline';
      }
    }
  },
  created: function created() {
    this.cbId = Math.random().toString(16).slice(2);
  }
});

/***/ }),

/***/ "uP4A":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "vNb6":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__ = __webpack_require__("0XqQ");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0331ce2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__ = __webpack_require__("VziK");
function injectStyle (ssrContext) {
  __webpack_require__("euVw")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-a0331ce2"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_StatsCard_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_a0331ce2_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_StatsCard_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wGY7":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_First_vue__ = __webpack_require__("QzOK");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40bbf77c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_First_vue__ = __webpack_require__("tRFf");
function injectStyle (ssrContext) {
  __webpack_require__("y5Fh")
}
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = injectStyle
/* scopeId */
var __vue_scopeId__ = "data-v-40bbf77c"
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_First_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_40bbf77c_hasScoped_true_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_First_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wH4b":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__ = __webpack_require__("1Kqs");
/* unused harmony namespace reexport */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__ = __webpack_require__("GJqE");
var normalizeComponent = __webpack_require__("VU/8")
/* script */


/* template */

/* template functional */
var __vue_template_functional__ = false
/* styles */
var __vue_styles__ = null
/* scopeId */
var __vue_scopeId__ = null
/* moduleIdentifier (server only) */
var __vue_module_identifier__ = null
var Component = normalizeComponent(
  __WEBPACK_IMPORTED_MODULE_0__babel_loader_node_modules_vue_loader_lib_selector_type_script_index_0_Radio_vue__["a" /* default */],
  __WEBPACK_IMPORTED_MODULE_1__node_modules_vue_loader_lib_template_compiler_index_id_data_v_2da06f95_hasScoped_false_transformToRequire_video_src_source_src_img_src_image_xlink_href_buble_transforms_node_modules_vue_loader_lib_selector_type_template_index_0_Radio_vue__["a" /* default */],
  __vue_template_functional__,
  __vue_styles__,
  __vue_scopeId__,
  __vue_module_identifier__
)

/* harmony default export */ __webpack_exports__["a"] = (Component.exports);


/***/ }),

/***/ "wt7y":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.fromApp)?_c('div',{attrs:{"id":"deeplink"}},[(_vm.os!=null)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"40%","padding":"30px"}},[_c('center',[_c('h3',[_vm._v("Загрузите приложение для "+_vm._s(_vm.os)+" по кнопке")])])],1)]):_vm._e(),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"padding":"3px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"20px"}},[_c('center',[_c('a',{staticClass:"btn btn-lg btn-info",attrs:{"href":_vm.href}},[_vm._v("Установить приложение")])])],1)])]),_vm._v(" "),_c('div',{staticClass:"col-xs-12",staticStyle:{"padding":"3px"}},[_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-12",staticStyle:{"margin-top":"20px"}},[_c('center',[_c('button',{staticClass:"btn btn-lg btn-danger",on:{"click":function($event){_vm.fromApp=1}}},[_vm._v("Продолжить тут")])])],1)])])]):_c('div',{attrs:{"id":"start"}},[(_vm.regNewDst)?_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("Регистрация нового поставщика")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))])]),_vm._v(" "),_c('div',{staticClass:"card-content"})])])]):_c('div',{staticClass:"row"},[_c('div',{staticClass:"col-xs-12",staticStyle:{"margin-top":"20px"}},[_c('div',{staticClass:"card"},[_c('div',{staticClass:"card-header"},[_c('h4',{staticClass:"card-title"},[_vm._v("А давайте зарегистрируемся")]),_vm._v(" "),_c('p',[_vm._v(_vm._s(_vm.message))]),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.phone),expression:"phone"}],key:_vm.pch,staticClass:"form-control",staticStyle:{"margin-top":"20px"},attrs:{"placeholder":"Телефон"},domProps:{"value":(_vm.phone)},on:{"input":function($event){if($event.target.composing){ return; }_vm.phone=$event.target.value}}}),_vm._v(" "),_c('input',{directives:[{name:"model",rawName:"v-model",value:(_vm.info),expression:"info"}],staticClass:"form-control",staticStyle:{"margin-top":"20px"},attrs:{"placeholder":"Комментарий"},domProps:{"value":(_vm.info)},on:{"input":function($event){if($event.target.composing){ return; }_vm.info=$event.target.value}}}),_vm._v(" "),_c('button',{staticClass:"btn btn-danger",staticStyle:{"margin-top":"20px"},attrs:{"disabled":_vm.btnOff},on:{"click":function($event){return _vm.buttonsave()}}},[_vm._v("Отправить")])]),_vm._v(" "),_c('div',{staticClass:"card-content"})])])])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
/* harmony default export */ __webpack_exports__["a"] = (esExports);

/***/ }),

/***/ "xJD8":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";

__webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, "x36W"));
new Promise(function(resolve) { resolve(); }).then(__webpack_require__.bind(null, "p4sG"));
/* harmony default export */ __webpack_exports__["a"] = ({});

/***/ }),

/***/ "y5Fh":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "yv97":
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ "zwtn":
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__("bOdI");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__ = __webpack_require__("Zcwg");
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition__);





/* harmony default export */ __webpack_exports__["a"] = ({
  components: __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()({}, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a.name, __WEBPACK_IMPORTED_MODULE_1_element_ui_lib_transitions_collapse_transition___default.a),
  props: {
    menu: {
      type: Boolean,
      default: false
    },
    link: {
      type: Object,
      default: function _default() {
        return {
          name: '',
          path: '',
          children: []
        };
      }
    }
  },
  provide: function provide() {
    return {
      addLink: this.addChild,
      removeLink: this.removeChild
    };
  },

  inject: {
    addLink: { default: null },
    removeLink: { default: null }
  },
  data: function data() {
    return {
      children: [],
      collapsed: true
    };
  },

  computed: {
    baseComponent: function baseComponent() {
      return this.isMenu || this.link.isRoute ? 'li' : 'router-link';
    },
    isMenu: function isMenu() {
      return this.children.length > 0 || this.menu === true;
    },
    isActive: function isActive() {
      var _this = this;

      if (this.$route) {
        var matchingRoute = this.children.find(function (c) {
          return _this.$route.path.startsWith(c.link.path);
        });
        if (matchingRoute !== undefined) {
          return true;
        }
      }
      return false;
    }
  },
  methods: {
    addChild: function addChild(item) {
      var index = this.$slots.default.indexOf(item.$vnode);
      this.children.splice(index, 0, item);
    },
    removeChild: function removeChild(item) {
      var tabs = this.children;
      var index = tabs.indexOf(item);
      tabs.splice(index, 1);
    },
    elementType: function elementType(link) {
      var isParent = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

      if (link.isRoute === false) {
        return isParent ? 'li' : 'a';
      } else {
        return 'router-link';
      }
    },
    linkAbbreviation: function linkAbbreviation(name) {
      var matches = name.match(/\b(\w)/g);
      return matches.join('');
    },
    collapseMenu: function collapseMenu() {
      this.collapsed = !this.collapsed;
    },
    collapseSubMenu: function collapseSubMenu(link) {
      link.collapsed = !link.collapsed;
    }
  },
  mounted: function mounted() {
    if (this.addLink) {
      this.addLink(this);
    }
    if (this.link.collapsed !== undefined) {
      this.collapsed = this.link.collapsed;
    }
    if (this.isActive && this.isMenu) {
      this.collapsed = false;
    }
  },
  destroyed: function destroyed() {
    if (this.$el && this.$el.parentNode) {
      this.$el.parentNode.removeChild(this.$el);
    }
    if (this.removeLink) {
      this.removeLink(this);
    }
  }
});

/***/ })

},["NHnr"]);


// WEBPACK FOOTER //
// static/js/app.87a16a278d68c6f40ceb.js